import React, { useState, useEffect, useRef } from "react";
import ReactPlayer from "react-player";
import { useParams, Link, useHistory } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import GenerateExamUrl from "../../components/GenerateExamUrl"; // Check the import path of component
// import ProgressBar from '../../components/Common/ProgressBar';
import close_icon from "../../assets/images/icon/close-icon.svg";
import delete_icon from "../../assets/images/icon/delete.svg";
import { Button, Container, Form, ProgressBar, Modal } from "react-bootstrap";
import { GetJobList } from "../../services/JobService";
import {
  fetchComptencyData,
  GetQuestionBehaviourList,
} from "../../services/hiringAssessmentService";
import api from "../../api";
// import ProgressBar from 'react-bootstrap/ProgressBar';
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import account from "../../assets/images/icon/account.svg";
import email from "../../assets/images/icon/email.svg";
import gendre from "../../assets/images/icon/gendre.svg";
import education from "../../assets/images/icon/education.svg";
import resume from "../../assets/images/icon/resume01.svg";
import mobile from "../../assets/images/icon/mobile.svg";
import calednder from "../../assets/images/icon/calender-li.svg";
import video_play from "../../assets/images/icon/video-play.svg";
import globe from "../../assets/images/globe.png";
import cricle_check from "../../assets/images/cricle-check.svg";
import cricle_check_gry from "../../assets/images/circle-check-grey.svg";
import cross from "../../assets/images/icon/cross.svg";
import edit_icon from "../../assets/images/icon/edit.svg";
import score from "../../assets/images/icon/scrore.svg";
import { Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import info_icon from "../../assets/images/icon/info_icon.svg";
import plus_icon from "../../assets/images/icon/plus.svg";
import smith_img from "../../assets/images/smith-img.svg";
import check_green from "../../assets/images/icon/check-green.svg";
import cross_icon from "../../assets/images/icon/cross-icon.svg";
import time_slot from "../../assets/images/time-slot-card.webp";
import referred_by from "../../assets/images/icon/referred-by.svg";
import {
  faAdd,
  faCalendarAlt,
  faEdit,
  faImages,
  faLock,
  faUpload,
  faUserAlt,
} from "@fortawesome/free-solid-svg-icons";
import { faStar, faStarHalfAlt } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import DatePicker from "react-datepicker";
import Swal from "sweetalert2";

import create_notes_plus from "../../assets/images/create-notes-plus.png";
import create_notes_plus1 from "../../assets/images/create-notes-plus-red.png";

import {
  CircularProgressbar,
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { decryptDataFromArray } from "helpers/EncDec";
import {
  addCandidateNotes,
  FetchCanditateDocuments,
  fetchGenders,
  fetchHiringSources,
  getAdminFeedbackData,
  getCandidateNotes,
  getCommunicationLogs,
  removeCandidateNotes,
  updateUserInfo,
  fetchPreAssessmentQuestions,
  ChangeCandidatePosition,
} from "helpers/backend_helper";
import { toast } from "react-toastify";
import {
  checkPermissionStatus,
  generateMaskedPII,
  getCompanyTimezoneDateTime,
  getSubdomain,
} from "helpers/utils";
import DegreesCertificates from "pages/UserDocuments/DegreesCertificates";
import { getUserInfo } from "helpers/authHelper";
import VoterDetails from "pages/UserDocuments/VoterDetails";
import DrivingLicense from "pages/UserDocuments/DrivingLicense";
import PassportDetails from "pages/UserDocuments/Passport";
import PreviousExperience from "pages/UserDocuments/PreviousExperience";
import { bytesToMB } from "helpers/common";

import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { GetEmployeeReferralList } from "services/EmployeeReferralService";
import { useTranslation } from "react-i18next";
import { set } from "lodash";
import PreAssessmentQuestions from "./PreAssessmentQuestions";
import DOMPurify from "dompurify";
// const getViewerUrl = (url, fileType) => {
//   if (fileType === "pdf") {
//     return url; // PDFs can be directly viewed
//   } else if (fileType === "doc" || fileType === "docx") {
//     return `https://docs.google.com/gview?url=${encodeURIComponent(
//       url
//     )}&embedded=true`;
//   } else if (fileType === "xls" || fileType === "xlsx") {
//     return `https://docs.google.com/gview?url=${encodeURIComponent(
//       url
//     )}&embedded=true`;
//   }
//   return url; // Fallback
// };

const STATUS_CHANGE_FROM_LABEL = {
  1: "Pending",
  2: "Screening",
  3: "Scheduled",
  4: "Selected",
  5: "Onboard",
  6: "On Hold",
  7: "Rejected",
};

const isBehaviourScoreEnabled =
  localStorage.getItem("isBehaviourScoreEnabled") === "true";
// console.log(isBehaviourScoreEnabled,'isBehaviourScoreEnabled')
//  console.log(localStorage.getItem("isBehaviourScoreEnabled"),'localStorage')
const ModalView = ({ isOpen, onClose, resumeUrl, fileType }) => {
  if (!isOpen) return null;

  // const viewerUrl = getViewerUrl(resumeUrl, fileType);
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>
          ×
        </button>
        <iframe
          src={resumeUrl}
          title="Document Viewer"
          sandbox="allow-same-origin allow-downloads"
          referrerPolicy="no-referrer"
        />
      </div>
    </div>
  );
};

const ViewDetails = () => {
  const { t } = useTranslation();
  const [error, setError] = useState([]);
  const [msg, setMsg] = useState("");
  const { appl_id } = useParams();
  const [candidateDetails, setCandidateDetails] = useState({});
  const isCandidateSelected =
    candidateDetails?.appr_reject === 1 &&
    candidateDetails?.appr_rejc_label === 3 &&
    (candidateDetails?.onboarding_req_send === 0 ||
      candidateDetails?.onboarding_req_send === 1);
  const [competencyData, setCompetencyData] = useState({});
  const [assessmentScore, setAssessmentScore] = useState({});
  const [screeningTestScore, setScreeningTestScore] = useState({
    competencyScores: 0,
    overallPercentage: 0,
    totalMarks: 0,
    scoredMarks: 0,
    totalQuestions: 0,
  });
  const [remarksHistory, setRemarksHistory] = useState([]);
  const [isPreAssessmentSubmitting, setIsPreAssessmentSubmitting] =
    useState(false);
  const [santimentDetails, setSantimentDetails] = useState({});
  const [videoUrl, setVideoUrl] = useState();
  const [trackerValues, setTrackerValues] = useState([]);
  const [timelineUpdates, setTimelineUpdates] = useState([]);
  const [documentData, setDocumentData] = useState("");
  const [resumeFile, setResumeFile] = useState(null);
  const [noteString, setNoteString] = useState("");
  const [allNotes, setAllNotes] = useState([]);
  const [isButtonVisible, setIsButtonVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const resumeUrl = candidateDetails?.job_user?.resume; // URL of the document
  const id = candidateDetails?.user_id;
  const fileType = resumeUrl?.split(".")?.pop() || ""; // Basic way to determine file type from URL
  const allowedTypes = ["pdf", "jpg", "jpeg", "png"];

  const [loading, setLoading] = useState(false); // To handle loading state
  const [resumeGenerated, setResumeGenerated] = useState(false);
  const isCVBuild = candidateDetails?.job_user?.isResumeBuilt;
  const generatedResumeUrl = candidateDetails?.job_user?.resume_filename;
  const [url, setResumeUrl] = useState(null);
  const [employeeReferralList, setEmployeeReferralList] = useState([]);
  const [referred, setReferred] = useState({});

  // Pre Assessment Data
  const [questionsData, setQuestionsData] = useState([]);
  const [answerData, setAnswerData] = useState({});
  const [workPermitErrors, setWorkPermitErrors] = useState("");
  // Communication Logs changes
  const [communicationLogs, setCommunicationLogs] = useState([]);
  const [feedbackData, setFeedbackData] = useState({});

  const [lang_id, setLangId] = useState(() => {
    const storedLangId = parseInt(localStorage.getItem("lang_id")) || 1;
    return storedLangId !== 1 ? String(storedLangId) : "1";
  });

  const [isPreAssessmentSubmitted, setIsPreAssessmentSubmitted] =
    useState(false);
  const [candidateScore, setCandidateScore] = useState(null);

  const userInfo = getUserInfo();

  const [showPositionModal, setShowPositionModal] = useState(false);
  const handleChangePosition = () => {
    fetchJobList();
    setShowPositionModal(true);
  };

  const handleClosePositionModal = () => {
    setShowPositionModal(false);
    setSelectedJob(null);
  };

  const [jobList, setJobList] = useState([]);
  const [selectedJob, setSelectedJob] = useState("");
  const [positionChangeReason, setPositionChangeReason] = useState("");
  const fetchJobList = async () => {
    let language_id = localStorage.getItem("lang_id");
    if (language_id) {
      await GetJobList("approved")
        .then(res => {
          let responseData = res.data;
          responseData = decryptDataFromArray(responseData);
          if (responseData?.status) {
            // console.log(candidateDetails, "candidateDetails");
            let currentJobId = candidateDetails?.vacancyId;
            // console.log(currentJobId, "currentJobId");
            let allJobs = responseData?.data
              ?.filter(el => el?.id !== currentJobId)
              ?.map(el => ({
                ...el,
                label: el?.title,
                value: el?.id,
              }));
            setJobList(allJobs);
          }
        })
        .catch(err => {
          console.log(err);
          toast.error("No data Available");
        });
    }
  };

  // Function to handle API request on button click
  const handleFileUpload = async () => {
    setLoading(true);
    try {
      if (isCVBuild === 1) {
        // Optionally, you might want to trigger the download here or redirect the user
        handleDownloadResume();
        return; // Exit the function early
      }

      const formData = new FormData();
      let file = await fetch(resumeUrl); // Fetch the file from the resumeUrl
      let fileName = file?.url?.split("/")?.pop(); // Extract filename
      file = await file.blob(); // Convert the file to a Blob
      formData.append("resume", file, fileName);
      // Perform API request using fetch
      const response = await fetch(
        "https://kfc.itsneobot.com:8080/cv/generation",
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.ok) {
        const result = await response.json();
        const fileName = result.file;
        setResumeUrl(fileName);
        setResumeGenerated(true);
        alert(t(`View Details.Resume generated successfully!`));
        // Save the resume filename to the database
        await api.post(
          `${process.env.REACT_APP_API_URL}/jobapply/admin/update-resume`,
          {
            user_id: id,
            resume_filename: fileName,
            isResumeBuilt: 1,
          }
        );
      } else {
        alert(t(`View Details.Failed to generate the resume`));
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      alert(t(`View Details.An error occurred while uploading the resume`));
    } finally {
      setLoading(false); // Set loading to false when process ends
    }
  };

  const handlePositionUpdate = async () => {
    if (!selectedJob) {
      toast.error("Please select a position");
      return;
    }

    if (!positionChangeReason?.trim()) {
      toast.error("Please enter reason");
      return;
    }

    try {
      setLoading(true);
      const payload = {
        vacancy_id: selectedJob?.value,
        reason: positionChangeReason?.trim() || "",
      };
      const res = await ChangeCandidatePosition(
        candidateDetails?.appl_id,
        payload
      );
      // console.log(res?.status, "res?.data?.status");
      if (res?.status) {
        toast.success(
          `Candidate position changed to ${res?.data?.new_position} successfully.`
        );

        setTimeout(() => {
          history.push("/all-applications");
        }, 1000);
      }
    } catch (error) {
      console.error("Change Position Error:", error);

      toast.error(
        error?.response?.data?.message || "Unable to change candidate position."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleFileUploadForResume = async e => {
    setErrors({ ...errors, resume: "" });
    const imageTypeAllowed = [
      "application/doc",
      "application/docx",
      "application/msword",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    if (e?.target?.files?.length > 0) {
      let maxSize = 25;
      let isError = false;
      if (e?.target?.files?.length > 1) {
        toast.error(t(`View Details.Cannot Select More than one Attachment`));
        return false;
      }
      for (let i = 0; i < e?.target?.files?.length; i++) {
        if (!imageTypeAllowed?.includes(e?.target?.files[i]?.type)) {
          isError = true;
        }
        let megabytes = bytesToMB(e?.target?.files[i].size);
        if (megabytes > maxSize) {
          toast.error(
            t(`View Details.Please select attachment of size below 25 MB`)
          );
          return false;
        }
        setResumeFile(e?.target?.files[i]);
      }
      if (isError) {
        toast.error(
          t(`View Details.Please upload attachment with the following types`)
        );
        return;
      }
    }
  };

  // Function to download the generated resume
  // Function to download the generated resume
  const handleDownloadResume = () => {
    const downloadUrl = generatedResumeUrl || url; // Use the existing resume URL
    if (downloadUrl) {
      // Construct the complete S3 URL using the generatedResumeUrl
      const resumeDownloadUrl = `https://s3.ap-south-1.amazonaws.com/neurotal-3.0-dev/CV_Format_Resumes/${downloadUrl}`;

      const link = document.createElement("a");
      link.href = resumeDownloadUrl; // S3 URL of the resume
      link.target = "_blank"; // Open in a new tab if needed

      // Extract the filename from the URL
      const fileName = resumeDownloadUrl.split("/").pop(); // Gets the last part of the URL
      link.download = fileName; // Set the download attribute

      // Append the link to the document and trigger a click
      document.body.appendChild(link);
      link.click();

      // Clean up by removing the link
      document.body.removeChild(link);
    } else {
      alert(
        t(`View Details.No resume generated Please build the resume first`)
      );
    }
  };

  // Edit User States
  const [editModal, setEditModal] = useState(false);
  const [editUserData, setEditUserData] = useState({});
  const [hiringSouces, setHiringSources] = useState([]);
  const [genderData, setGenders] = useState([]);
  const [errors, setErrors] = useState({});

  const closeVideoPopup = () => {
    setVideoUrl("");
  };
  const fixedProgressValues = [20, 40, 60, 80, 100];
  const [progressIndex, setProgressIndex] = useState(0);

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  useEffect(() => {
    const cycleProgressValues = () => {
      setProgressIndex(
        prevIndex => (prevIndex + 1) % fixedProgressValues.length
      );
    };

    const interval = setInterval(() => {
      const random = Math.floor(Math.random() * 100) + 1;
      setRandomNumber(random);
    }, 10000000);
    return () => clearInterval(interval);
  }, []);

  const [randomNumber, setRandomNumber] = useState(null);

  const handleEditUser = () => {
    let userData = {
      name: candidateDetails?.name,
      email_id: candidateDetails?.email_id,
      mobile: candidateDetails?.mobile,
      gender: candidateDetails?.job_user?.gender,
      dob: candidateDetails?.job_user?.dob
        ? new Date(candidateDetails?.job_user?.dob)
        : "",
      job_portal_name:
        parseInt(candidateDetails?.job_user?.job_portal_name) || "",
      appl_id: candidateDetails?.appl_id,
    };
    setResumeFile(candidateDetails?.job_user?.resume);
    setEditUserData(userData);
    setEditModal(true);
  };

  const getHiringSources = async () => {
    await fetchHiringSources()
      .then(res => {
        let responseData = res?.hiringSouces || [];
        setHiringSources(responseData);
      })
      .catch(err => {
        toast.error(t(`View Details.No data Available`));
      });
  };

  const handleUserSubmit = async () => {
    let { isValid, newErrors } = validateForm(editUserData);
    if (!isValid) {
      setErrors(newErrors);
      toast.error(t(`View Details.Please fill all required details!`));
      return;
    } else {
      let oldUserData = {
        name: candidateDetails?.name,
        email_id: candidateDetails?.email_id,
        mobile: candidateDetails?.mobile,
        gender: candidateDetails?.job_user?.gender,
        dob: candidateDetails?.job_user?.dob
          ? new Date(candidateDetails?.job_user?.dob)
          : "",
        job_portal_name:
          parseInt(candidateDetails?.job_user?.job_portal_name) || "",
        appl_id: candidateDetails?.appl_id,
      };

      let updatedFields = [];
      Object.keys(editUserData)?.map(el => {
        if (
          el === "dob" &&
          editUserData["dob"] &&
          oldUserData["dob"] &&
          editUserData["dob"]?.getFullYear() ===
            oldUserData["dob"]?.getFullYear() &&
          editUserData["dob"]?.getMonth() === oldUserData["dob"]?.getMonth() &&
          editUserData["dob"]?.getDate() === oldUserData["dob"]?.getDate()
        ) {
          return false;
        }
        if (editUserData[el] !== oldUserData[el] && el !== appl_id) {
          updatedFields.push(el?.split("_")?.join(" "));
        }
      });
      if (candidateDetails?.job_user?.resume !== resumeFile) {
        updatedFields.push("resume");
      }

      await updateUserInfo({
        ...editUserData,
        new_status: updatedFields?.join(", "),
        resume: resumeFile,
      })
        .then(res => {
          toast.success(t(`View Details.User Details Updated Successfully!`));
          fetchData();
        })
        .catch(err => {
          let errMsg =
            err?.response?.data?.message ||
            t(`View Details.Something went wrong`);
          toast.error(errMsg);
        });
      setEditModal(false);
      setEditUserData({});
    }
  };

  const validateForm = userData => {
    let isValid = true;
    let newErrors = {};
    let nameRegex = /^[A-Za-z\s]{1,}[\.]{0,1}[A-Za-z\s]{0,}$/;
    let mobileRegex = /^[1-9][0-9]{9}$/;
    if (!userData?.name || !nameRegex.test(userData?.name)) {
      newErrors.name = t(`View Details.Valid User Name is required`);
      isValid = false;
    }
    if (!userData?.email_id) {
      newErrors.email_id = t(`View Details.Email ID is required`);
      isValid = false;
    }
    if (!userData?.mobile || !mobileRegex.test(userData?.mobile)) {
      newErrors.mobile = t(`View Details.Valid Mobile Number is required`);
      isValid = false;
    }
    if (!userData?.gender) {
      newErrors.gender = t(`View Details.Gender is required`);
      isValid = false;
    }
    if (!userData?.dob) {
      newErrors.dob = t(`View Details.DOB is required`);
      isValid = false;
    }
    if (!userData?.job_portal_name) {
      newErrors.job_portal_name = t(`View Details.Job Portal is required`);
      isValid = false;
    }
    return { isValid, newErrors };
  };

  useEffect(() => {
    const random = Math.floor(Math.random() * 100) + 1; // Generate random number between 1 and 100
    setRandomNumber(random);
    const interval = setInterval(() => {
      const random = Math.floor(Math.random() * 100) + 1;
      setRandomNumber(random);
    }, 10000000);
    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, []);

  const [randomNumber1, setRandomNumber1] = useState(null);

  useEffect(() => {
    const random = Math.floor(Math.random() * 100) + 1; // Generate random number between 1 and 100
    setRandomNumber1(random);
    const interval = setInterval(() => {
      const random = Math.floor(Math.random() * 100) + 1;
      setRandomNumber(random);
    }, 10000000);
    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, []);

  const [randomNumber2, setRandomNumber2] = useState(null);

  useEffect(() => {
    const random = Math.floor(Math.random() * 100) + 1; // Generate random number between 1 and 100
    setRandomNumber2(random);
    const interval = setInterval(() => {
      const random = Math.floor(Math.random() * 100) + 1;
      setRandomNumber(random);
    }, 10000000);
    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, []);

  const fetchData = async () => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_API_URL}/admin/candidate-details/fetch-details/${appl_id}`
      );
      let responseData = response.data;
      responseData = decryptDataFromArray(responseData);
      // console.log(JSON.stringify(responseData), "responseData");
      if (responseData?.status && responseData?.data?.length > 0) {
        setCandidateDetails(responseData?.data?.[0]);
        setTimelineUpdates(responseData?.timelineDetails || []);
        setTrackerValues(responseData?.trackerValues || []);
        setRemarksHistory(responseData?.remarksHistory || []);
        try {
          setSantimentDetails(
            JSON.parse(responseData?.data?.[0]?.emotionInfo || "{}")
          );
        } catch (e) {
          setSantimentDetails({});
        }
      } else {
        setMsg("Invalid data format received from API");
      }
    } catch (error) {
      setMsg("Error fetching candidate details");
    }
  };

  const fetchCandidateNotes = async () => {
    if (!appl_id) {
      return;
    }
    await getCandidateNotes(appl_id)
      .then(res => {
        setAllNotes(res?.data || []);
      })
      .catch(err => {
        let errMsg =
          err?.response?.data?.message ||
          t(`View Details.Something went wrong`);
        toast.error(errMsg);
      });
  };

  const fetchCommunicationLogs = async () => {
    if (!appl_id) {
      return;
    }
    await getCommunicationLogs(appl_id)
      .then(res => {
        let responseData = decryptDataFromArray(res);
        setCommunicationLogs(responseData?.data || []);
      })
      .catch(err => {
        let errMsg =
          err?.response?.data?.message ||
          t(`View Details.Something went wrong`);
        toast.error(errMsg);
      });
  };

  const fetchFeedbackData = async () => {
    if (!appl_id) {
      return;
    }
    await getAdminFeedbackData(appl_id)
      .then(res => {
        let responseData = decryptDataFromArray(res);
        setFeedbackData(responseData?.data || {});
      })
      .catch(err => {
        let errMsg =
          err?.response?.data?.message ||
          t(`View Details.Something went wrong`);
        toast.error(errMsg);
      });
  };

  const fetchPreassessmentData = async () => {
    if (!appl_id) return;

    await fetchPreAssessmentQuestions(appl_id)
      .then(res => {
        setIsPreAssessmentSubmitted(res?.is_preassessment_submitted);
        setCandidateScore(res?.candidate_score);
        setQuestionsData(res?.questions || []);

        // ✅ NEW: hydrate answers for UI
        if (
          res?.is_preassessment_submitted &&
          res?.submitted_answers?.quest_ids
        ) {
          const hydratedAnswers = {};

          Object.values(res.submitted_answers.quest_ids).forEach(group => {
            Object.values(group).forEach(q => {
              hydratedAnswers[q.id] = q.answerValue;
            });
          });

          setAnswerData(hydratedAnswers);
        }
      })
      .catch(err => {
        toast.error(
          err?.response?.data?.message || t(`View Details.Something went wrong`)
        );
      });
  };

  const getUserDocInfo = async () => {
    let user_id = candidateDetails?.user_id;
    if (!user_id) {
      return false;
    }
    await FetchCanditateDocuments(user_id)
      .then(res => {
        let responseData = decryptDataFromArray(res?.data);

        setDocumentData(responseData);
      })
      .catch(err => {});
  };
  const { allFeedbacks, averageScore, ratingCounts } = feedbackData || {};
  useEffect(() => {
    fetchData();
    getHiringSources();
    fetchCandidateNotes();
    fetchCommunicationLogs();
    fetchFeedbackData();
    fetchPreassessmentData();
    fetchGenders().then(genders => setGenders(genders));
    // Fetch competency Data

    fetchComptencyData(lang_id)
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        if (responseData?.status) {
          const comptArr = {};

          Object.entries(responseData?.data).forEach(([c_key, c_value], c) => {
            comptArr[c_value.id] = c_value.name;
          });

          setCompetencyData(comptArr);
        }
      })
      .catch(error => {
        setError("No data Available");
      });
  }, [appl_id]);

  const validatePreassesmentDetails = () => {
    let validationError = {};
    if (
      questionsData?.length > 0 &&
      questionsData?.length !== Object.keys(answerData)?.length
    ) {
      validationError.questionError = t(`Please answer required questions`);
    }
    setWorkPermitErrors(validationError);
    return Object.values(validationError).every(error => !error);
  };

  // Function to fetch employee referral list and check for matching email
  const fetchEmployeeReferralList = async () => {
    try {
      const res = await GetEmployeeReferralList();
      if (res?.status === 200) {
        const employeeList = res?.data?.data || [];
        setEmployeeReferralList(employeeList);

        // If candidate details are already available, check for email match
        if (candidateDetails?.email_id) {
          // console.log(candidateDetails?.email_id);
          // console.log("Employee List:", employeeList);
          const matchingEmployee = employeeList.find(
            emp => emp.candidate_email === candidateDetails?.email_id
          );
          // console.log(matchingEmployee);
          if (matchingEmployee) {
            setReferred(matchingEmployee);
          }
        }
      } else {
        toast.error(t(`View Details.No data available`));
      }
    } catch (err) {
      toast.error(t(`View Details.Error fetching employee referral list`));
    }
  };

  // Fetch employee referral list only when `candidateDetails` changes
  useEffect(() => {
    if (candidateDetails?.email_id) {
      fetchEmployeeReferralList();
    }
  }, [candidateDetails]); // Triggered only when `candidateDetails` changes

  // useEffect(() => {
  //   if (candidateDetails.hiring_assessments?.questions_value) {
  //     const questions_value_obj = JSON.parse(candidateDetails.hiring_assessments.questions_value);
  //     const questIds = questions_value_obj.quest_ids;

  //     const Arr = [];
  //     let ArrTotalCompt = 0;
  //     let totalSize = 0;

  //     const Arr1 = {
  //       option1: 'weightage1',
  //       option2: 'weightage2',
  //       option3: 'weightage3',
  //       option4: 'weightage4',
  //     };

  //     Object.entries(questIds).forEach(([key, value], i) => {
  //       var size = Object.keys(value).length;
  //       totalSize += Object.keys(value).length;

  //       if (!Arr[key]) {
  //         Arr[key] = { sum: 0 };
  //       }

  //       Object.entries(value).forEach(([key1, value1], j) => {
  //         Arr[key].sum += parseInt(value1[Arr1[value1.answerValue]], 10);
  //       });

  //       ArrTotalCompt += Arr[key].sum;
  //       Arr[key].per = Math.round((Arr[key].sum / (size * 4)) * 100);
  //     });

  //     Arr.compt_avg_per = Math.round((ArrTotalCompt / (totalSize * 4)) * 100);
  //     setAssessmentScore(Arr);
  //     console.log('setAssessmentScore::',Arr);
  //   }
  // }, [candidateDetails]);

  const [questionBehaviourList, setQuestionBehaviourList] = useState("");
  const history = useHistory();

  useEffect(() => {
    if (candidateDetails.hiring_assessments?.questions_value) {
      let questions_value_obj = {};

      try {
        questions_value_obj = JSON.parse(
          candidateDetails.hiring_assessments.questions_value || "{}"
        );
      } catch (e) {
        console.error("Invalid questions JSON:", e);
        questions_value_obj = {};
      }
      const questIds = questions_value_obj.quest_ids || {};

      const Arr = [];
      const Arr_behav = [];
      let ArrTotalCompt = 0;
      let totalSize = 0;
      let ques_behav_id_arr = [];
      let ques_behav_ids = [];

      const Arr1 = {
        option1: "weightage1",
        option2: "weightage2",
        option3: "weightage3",
        option4: "weightage4",
      };
      let sum_weightage = "";

      Object.entries(questIds).forEach(([key, value], i) => {
        //console.log('key:166',key);
        // console.log('key:167',value);

        var size = Object.keys(value).length;
        totalSize += Object.keys(value).length;

        if (!Arr[key]) {
          Arr[key] = { sum: 0 };
        }
        if (!Arr[key]) {
          Arr[key] = { behav_sum: 0 };
        }

        Object.entries(value).forEach(([key1, value1], j) => {
          Arr[key].sum += parseInt(value1[Arr1[value1.answerValue]], 10);
          sum_weightage += parseInt(value1[Arr1[value1.answerValue]], 10);
          ques_behav_id_arr.push(value1.ques_behav_id);
          ques_behav_ids = value1.ques_behav_id; // [1,2,3]

          //alert(value1[Arr1[value1.answerValue]])

          //Fetch behaviours
          // GetQuestionBehaviourList(value1.vacancy_type_id)
          // .then(res => {
          //   if (res?.status === 200) {
          //     setQuestionBehaviourList(res?.data?.data);
          //     const behaviorData = res?.data?.data;

          //     behaviorData.forEach((behav_value, behav_key) => {

          //       const foundBehavior = behaviorData.find(behav => ques_behav_ids.includes(behav.id));
          //       if (foundBehavior) {
          //         //console.log('Behavior found:', foundBehavior);
          //         console.log('behav_value?.ques_behav:', behav_value?.ques_behav);

          //         Arr_behav[behav_value?.ques_behav].behav_sum += parseInt(value1[Arr1[value1.answerValue]], 10);
          //       console.log('Arr_behav',Arr_behav);

          //       }
          //       else {
          //         console.log('Behavior not found in ques_behav_ids');
          //       }

          //     });

          //   }
          // })
          // .catch(err => {
          //   console.error("No data Available");
          // });
        });

        // console.log('questionBehaviourList',questionBehaviourList);

        ArrTotalCompt += Arr[key].sum;
        Arr[key].per = Math.round((Arr[key].sum / (size * 2)) * 100);
      });
      // Flatten and parse ques_behav_id_arr
      // ques_behav_id_arr = ques_behav_id_arr.flatMap(ids => JSON.parse(ids));

      // console.log('ques_behav_id_arr', ques_behav_id_arr); // Merged and parsed array of ques_behav_id

      // console.log('sum_weightage188',sum_weightage);
      const compt_avg_per =
        totalSize > 0 ? Math.round((ArrTotalCompt / (totalSize * 2)) * 100) : 0;
      Arr.compt_avg_per = isNaN(compt_avg_per) ? 0 : compt_avg_per;

      setAssessmentScore(Arr);
      //console.log("setAssessmentScore::", Arr);
    }
    getUserDocInfo();
  }, [candidateDetails]);

  const toggleVideoPopup = link => {
    setVideoUrl(link);
  };

  // Function to handle the click event and navigate to the previous page
  const handleClick = () => {
    history.goBack(); // Navigate to the previous page
  };

  const onSubmit = () => {
    getUserDocInfo();
  };

  const handleAttachmentOpen = () => {
    if (resumeFile) {
      if (typeof resumeFile === "string") {
        const allowedDomain = "amazonaws.com";

        if (resumeFile.includes(allowedDomain)) {
          window.open(resumeFile, "_blank", "noopener,noreferrer");
        }
      } else {
        window.open(URL.createObjectURL(resumeFile));
      }
    }
  };
  const handleAttachmentOpen2 = () => {
    const file = candidateDetails?.job_user?.work_permit_document;

    if (file) {
      if (typeof file === "string") {
        const allowedDomain = "amazonaws.com";

        if (file.includes(allowedDomain)) {
          window.open(file, "_blank", "noopener,noreferrer");
        } else {
          toast.error("Invalid file URL");
        }
      } else {
        window.open(URL.createObjectURL(file));
      }
    }
  };

  const handleDivClick = () => {
    setIsButtonVisible(!isButtonVisible); // Toggles the button visibility
  };

  const handleCloseClick = () => {
    setIsButtonVisible(false); // Close when cross button is clicked
  };

  const handleAddNote = async () => {
    if (!noteString?.trim()) {
      toast.warn(t(`View Details.Cannot Add Empty Note!`));
    }
    if (!appl_id) {
      return;
    }
    await addCandidateNotes(appl_id, { noteString: noteString })
      .then(res => {
        toast.success(t(`View Details.Note Added Successfully!`));
        setNoteString("");
        fetchCandidateNotes();
      })
      .catch(err => {
        let errMsg =
          err?.response?.data?.message ||
          t(`View Details.Something went wrong`);
        toast.error(errMsg);
      });
  };

  const handleRemoveNote = async item => {
    if (!appl_id || !item) {
      return;
    }
    if (item?.admin_id !== userInfo?.id) {
      toast.warn(
        t(`View Details.Notes can only be modified by admin who created it!`)
      );
      return;
    }
    await removeCandidateNotes(appl_id, { noteId: item?.id })
      .then(res => {
        toast.success(t(`View Details.Note Removed Successfully!`));
        fetchCandidateNotes();
      })
      .catch(err => {
        let errMsg =
          err?.response?.data?.message ||
          t(`View Details.Something went wrong`);
        toast.error(errMsg);
      });
  };

  const handleCancelEdit = () => {
    setEditModal(false);
    setEditUserData({});
  };

  const validatePreAssessment = () => {
    if (!questionsData?.length) return true;

    const unanswered = questionsData.find(q => {
      const qId = q.question_id;
      return !answerData?.[qId];
    });

    if (unanswered) {
      toast.warning(
        "Please answer all pre-assessment questions before submitting",
        {
          autoClose: 3000,
        }
      );

      // 🎯 Smooth scroll to first unanswered question
      const el = document.getElementById(`pre-q-${unanswered.question_id}`);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        el.classList.add("shake-error");
        setTimeout(() => el.classList.remove("shake-error"), 600);
      }

      return false;
    }

    return true;
  };

  const handleSubmitPermit = async e => {
    e.preventDefault();

    // ❌ Stop submit if validation fails
    if (!validatePreAssessment()) return;
    setIsPreAssessmentSubmitting(true);
    try {
      let payload = {
        user_id: candidateDetails?.user_id,
        vacancy_id: candidateDetails?.vacancyId,
      };

      let formDataNew = new FormData();
      Object.keys(payload).forEach(key => {
        formDataNew.append(key, payload[key]);
      });

      formDataNew.append("answerData", JSON.stringify(answerData));
      formDataNew.append(
        "checkAssessment",
        questionsData?.length > 0 ? "Yes" : "No"
      );

      const langId = localStorage.getItem("lang_id") || "1";

      formDataNew.append("application_id", candidateDetails?.appl_id);
      formDataNew.append("lang_alias", langId);

      await api.post(
        `${process.env.REACT_APP_API_URL}/jobapply/save_preassessment/${candidateDetails?.vacancyId}`,
        formDataNew,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      toast.success("Pre-assessment submitted successfully");

      // 🔁 Refresh score + checked answers
      await fetchPreassessmentData();
      await fetchData();
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong. Please try again."
      );
    } finally {
      setIsPreAssessmentSubmitting(false);
    }
  };

  const handleViewReport = () => {
    const sanitizeText = val =>
      DOMPurify.sanitize(String(val ?? ""), {
        ALLOWED_TAGS: [],
        ALLOWED_ATTR: [],
      });

    // Retrieve candidate details
    const candidateName = sanitizeText(candidateDetails?.name) || "N/A";
    const candidateEmail =
      generateMaskedPII(candidateDetails?.email_id) || "N/A";
    const candidateMobile =
      generateMaskedPII(candidateDetails?.mobile, 2) || "N/A";
    const candidateGender =
      sanitizeText(candidateDetails?.job_user?.gender) || "N/A";

    // Retrieve assessment scores (Assuming assessmentScore is an object)
    const scores = assessmentScore || {};

    // Retrieve nested questions data
    let questionsData = {};

    try {
      questionsData =
        JSON.parse(
          candidateDetails?.hiring_assessments?.questions_value || "{}"
        )?.quest_ids || {};
    } catch (e) {
      console.error("Invalid report JSON:", e);
      questionsData = {};
    }

    // Filter out compt_avg_per from the scores
    const filteredScores = Object.entries(scores).filter(
      ([key]) => key !== "compt_avg_per"
    );

    // Generate HTML for the questions, options, and answers
    const questionsHtml = Object.entries(questionsData)
      .map(([competencyId, questions]) => {
        // Heading for each competency
        const competencyHeading =
          sanitizeText(competencyData[competencyId]) ||
          `Competency ${sanitizeText(competencyId)}`;

        const questionsHtmlForCompetency = Object.entries(questions)
          .map(([questionId, questionObj], index) => {
            const questionText =
              sanitizeText(questionObj.question) || `Question ${index + 1}`;
            const options = [
              sanitizeText(questionObj.option1) || "N/A",
              sanitizeText(questionObj.option2) || "N/A",
              sanitizeText(questionObj.option3) || "N/A",
              sanitizeText(questionObj.option4) || "N/A",
            ];
            const correctAnswer = sanitizeText(questionObj.answer) || "N/A";
            const candidateAnswer =
              sanitizeText(questionObj.answerValue) || "N/A";

            return `
              <div class="question-block">
                <div class="question-text"><strong>Q${
                  index + 1
                }:</strong> ${questionText}</div>
                <div class="options">
                  <strong>Options:</strong>
                  <div style="margin-bottom: 10px;"> <!-- Space below options -->
                    ${options
                      .map(
                        (option, i) => `
                          <span style="display: block; margin: 5px 0;">${
                            i + 1
                          }. ${option}</span>
                        `
                      )
                      .join("")}
                  </div>
                </div>
                <div class="answer-row" style="display: flex; align-items: center; margin-top: 10px;"> <!-- Space above answers -->
                  <div class="candidate-answer" style="margin-right: 60px;">
                    <strong>Candidate's Answer:</strong> ${candidateAnswer}
                  </div>
                  <div class="correct-answer">
                    <strong>Correct Answer:</strong> ${correctAnswer}
                  </div>
                </div>
              </div>
              <br /> <!-- Line break between each question -->
            `;
          })
          .join("");

        return `
          <div class="competency-section">
            <h3 style="text-align: center;">${competencyHeading}</h3> <!-- Competency heading centered -->
            ${questionsHtmlForCompetency}
          </div>
        `;
      })
      .join("");

    // Create the HTML for the report
    const reportHtml = `
      <html>
        <head>
          <title>Candidate Report</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
              margin: 0; /* Remove default margin */
            }
            h2 {
              color: #007bff; /* Blue color for heading */
              text-align: center; /* Center the main heading */
            }
            .competency-section h3 {
              color: #333; /* Darker color for competency headings */
              margin-top: 20px; /* Space above competency headings */
              text-align: center; /* Center align competency headings */
            }
            .info-row {
              display: flex; /* Use flexbox for layout */
              justify-content: space-between; /* Space between items */
              margin: 20px 0; /* Margin for spacing */
              font-size: 16px;
              border-bottom: 1px solid #ddd; /* Line separator */
              padding-bottom: 10px; /* Space below */
            }
            .info-label {
              flex: 1; /* Each label takes equal space */
              text-align: center; /* Center align labels */
              font-weight: bold; /* Make labels bold */
            }
            .info-value {
              flex: 1; /* Each value takes equal space */
              text-align: center; /* Center align values */
            }
            .score-details {
              margin-top: 10px; /* Reduced space between info and score details */
              padding-top: 10px; /* Space above score details */
            }
            .score-header {
              text-align: center; /* Center align score header */
              margin-bottom: 10px; /* Space below the header */
            }
            .score-row {
              display: flex; /* Use flexbox for score layout */
              justify-content: space-between; /* Space between competency and score */
              margin: 5px 0; /* Margin for spacing between rows */
              font-size: 16px; /* Increase font size for clarity */
              padding: 10px 0; /* Padding for better spacing */
            }
            .competency {
              text-align: left; /* Align competency to the left */
              flex: 1; /* Take up remaining space */
            }
            .score {
              text-align: right; /* Align score to the right */
              margin-left: 20px; /* Space between competency and score */
            }
            .question-block {
              margin-top: 20px;
              border-top: 1px solid #ddd;
              padding-top: 10px;
            }
            .options {
              margin-top: 10px;
            }
          </style>
        </head>
        <body>
          <h2>Candidate Report</h2>
          
          <!-- Info Row for Name, Email, Mobile Number, and Gender -->
          <div class="info-row">
            <div class="info-label">Name</div>
            <div class="info-value">${candidateName}</div>
            <div class="info-label">Email</div>
            <div class="info-value">${candidateEmail}</div>
            <div class="info-label">Mobile</div>
            <div class="info-value">${candidateMobile}</div>
            <div class="info-label">Gender</div>
            <div class="info-value">${candidateGender}</div>
          </div>
         
          <!-- Score Details -->
          <div class="score-details">
            <h3 class="score-header">Score details as per competency category</h3>
            ${filteredScores
              .map(
                ([key_, value_]) => `
                <div class="score-row">
                  <div class="competency">${sanitizeText(
                    competencyData[key_] || key_
                  )}</div>
                  <div class="score">${Number(value_.per) || 0}%</div>
                </div>
              `
              )
              .join("")}
          </div>
  
          <!-- Append questions HTML here -->
          ${questionsHtml}
        </body>
      </html>
    `;

    // Create an invisible iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0px";
    iframe.style.height = "0px";
    iframe.style.border = "none";

    // Append the iframe to the body
    document.body.appendChild(iframe);

    // Write the report HTML to the iframe's document
    const doc = iframe.contentWindow.document;
    doc.open();
    const safeHtml = DOMPurify.sanitize(reportHtml, {
      WHOLE_DOCUMENT: true,
      FORCE_BODY: false,
    });

    doc.write(safeHtml);
    doc.close();

    // Trigger the print function from the iframe
    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    // Remove the iframe after printing
    iframe.onload = function () {
      iframe.parentNode.removeChild(iframe);
    };
  };

  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const [readMoreStates, setReadMoreStates] = useState({});

  const toggleReadMore = id => {
    setReadMoreStates(prevState => ({
      ...prevState,
      [id]: !prevState[id], // Toggle the read more state for the card with this id
    }));
  };

  //arrow-table
  const [isFocused, setIsFocused] = useState(false);

  const tabWrapperRef = useRef(null);

  const scrollLeft = () => {
    let moveDistance;

    if (window.innerWidth >= 1400) {
      moveDistance = 20; // For 1400px and wider
    } else if (window.innerWidth < 1400 && window.innerWidth >= 1280) {
      moveDistance = 20; // For 1280px to 1399px
    } else if (window.innerWidth < 1280) {
      moveDistance = 50; // For less than 1280px
    }

    if (tabWrapperRef.current) {
      tabWrapperRef.current.style.transform = `translateX(${moveDistance}px)`;
    }
  };

  const scrollRight = () => {
    let moveDistance;

    if (window.innerWidth >= 1400) {
      moveDistance = 100; // For 1400px and wider
    } else if (window.innerWidth >= 1280) {
      moveDistance = 300; // For 1280px to 1399px
    } else if (window.innerWidth >= 1152) {
      moveDistance = 350; // For 1152px to 1279px
    } else {
      moveDistance = 100; // For less than 1152px
    }

    if (tabWrapperRef.current) {
      tabWrapperRef.current.style.transform = `translateX(-${moveDistance}px)`;
    }
  };

  const [activeTab, setActiveTab] = useState("application");

  const handleTabClick = tab => {
    setActiveTab(tab);
    setSelectedOption(null);
  };

  // Function to create options based on trackerValues
  const createOptions = candidateDetails => {
    const hiringAssessments = candidateDetails?.hiring_assessments || [];
    return hiringAssessments
      .filter(assessment => !assessment.exam_url.includes("&type=interviewer"))
      .map(assessment => ({
        value: assessment.interview_type_id,
        label: assessment.interview_title,
      }));
  };

  // Generate options dynamically
  const options = createOptions(candidateDetails);

  const interviewerOptions = candidateDetails => {
    const hiringAssessments = candidateDetails?.hiring_assessments || [];
    const uniqueInterviewers = {};

    return hiringAssessments.reduce((acc, assessment) => {
      if (!uniqueInterviewers[assessment.interviewer_id]) {
        uniqueInterviewers[assessment.interviewer_id] = true;
        acc.push({
          value: assessment.interviewer_id,
          label: assessment.interviewer,
        });
      }
      return acc;
    }, []);
  };

  const intervieweropt = interviewerOptions(candidateDetails);

  const [selectedInterviewerOption, setselectedInterviewerOption] =
    useState(null);

  const handleinterviewerChange = selectedInterviewerOption => {
    setselectedInterviewerOption(selectedInterviewerOption);
  };

  const [selectedOption, setSelectedOption] = useState(null);

  const handleChange = selectedOption => {
    setSelectedOption(selectedOption);
  };

  // Function to create options based on trackerValues
  const createroundoption = candidateDetails => {
    const hiringAssessments = candidateDetails?.hiring_assessments || [];
    const uniqueRounds = {};

    return hiringAssessments
      .filter(assessment => assessment.exam_url.includes("&type=interviewer"))
      .reduce((acc, assessment) => {
        if (!uniqueRounds[assessment.interview_type_id]) {
          uniqueRounds[assessment.interview_type_id] = true;
          acc.push({
            value: assessment.interview_type_id,
            label: assessment.interview_title,
          });
        }
        return acc;
      }, []);
  };

  let questCounter = 1;

  const getWeightageFromOption = question => {
    if (question.answer === "option1") return Number(question.weightage1);
    else if (question.answer === "option2") return Number(question.weightage2);
    else if (question.answer === "option3") return Number(question.weightage3);
    else if (question.answer === "option4") return Number(question.weightage4);
  };

  const calculateCompetencyScores = () => {
    const scores = {};
    let overallTotalWeightage = 0;
    let overallAnsweredWeightage = 0;
    let totalQuestions = 0;

    const selectedAssessment = (
      candidateDetails?.hiring_assessments || []
    ).find(
      assessment =>
        assessment.interview_type_id === selectedOption?.value &&
        (activeTab === "screening"
          ? true
          : assessment.interviewer_id === selectedInterviewerOption?.value)
    );

    let parsedQuestions = {};

    try {
      parsedQuestions = JSON.parse(selectedAssessment?.questions_value || "{}");
    } catch (e) {
      parsedQuestions = {};
      console.error("Invalid JSON:", e);
    }
    if (parsedQuestions?.quest_ids) {
      Object.entries(parsedQuestions.quest_ids).forEach(
        ([compId, questions]) => {
          let totalWeightage = 0;
          let answeredWeightage = 0;
          Object.values(questions)?.forEach((elem, ind) => {
            totalQuestions++;
            totalWeightage += Math.max(
              elem.weightage1,
              elem.weightage2,
              elem.weightage3,
              elem.weightage4
            );
            if (
              elem.answer === elem.answerValue ||
              elem[elem.answer] === elem.answerValue
            ) {
              answeredWeightage += getWeightageFromOption(elem);
            }
          });
          overallTotalWeightage += Number(totalWeightage);
          overallAnsweredWeightage += Number(answeredWeightage);

          const competencyScore =
            totalWeightage > 0
              ? Math.round((answeredWeightage / totalWeightage) * 100)
              : 0;

          scores[compId] = {
            score: competencyScore,
            title: competencyData[compId],
          };
        }
      );
    }
    const overallPercentage =
      overallTotalWeightage > 0
        ? (overallAnsweredWeightage / overallTotalWeightage) * 100
        : 0;

    return {
      competencyScores: scores,
      overallPercentage: overallPercentage,
      totalMarks: overallTotalWeightage,
      scoredMarks: overallAnsweredWeightage,
      totalQuestions: totalQuestions,
    };
  };

  const renderScreenTestQuestion = () => {
    let questionMap = new Map();

    let parsedQuestionData = {};

    try {
      parsedQuestionData = JSON.parse(
        (candidateDetails?.hiring_assessments || []).find(
          assessment => assessment.interview_type_id === selectedOption?.value
        )?.questions_value || "{}"
      );
    } catch (e) {
      console.error("Invalid question data:", e);
    }

    let questionIds = parsedQuestionData?.quest_ids || {};

    for (let compId of Object.keys(questionIds)) {
      let questions = questionIds?.[compId] || {};

      for (let questionId of Object.keys(questions || {})) {
        let questionData = questions?.[questionId] || {};

        let question = questionMap.get(questionId);

        if (!question) {
          let questionWeightage = Math.max(
            questionData.weightage1,
            questionData.weightage2,
            questionData.weightage3,
            questionData.weightage4
          );

          let answerValue = questionData?.answerValue;

          if (
            ["option1", "option2", "option3", "option4"].includes(answerValue)
          ) {
            answerValue = questionData?.[answerValue];
          } else if (!answerValue) {
            answerValue = null;
          }

          let isAnsCorrect =
            questionData.answerValue === questionData.answer ||
            questionData.answerValue === questionData[questionData.answer];

          question = {
            ...questionData,
            questionWeightage: questionWeightage,
            answerValue: answerValue,
            isAnsCorrect: isAnsCorrect,
          };
        }

        let existingCompts = question?.competencies || [];
        let thisQuestionCompStr = competencyData?.[compId]?.trim();
        existingCompts.push(thisQuestionCompStr);

        question = {
          ...question,
          competencies: [...new Set([...existingCompts])],
        };

        questionMap.set(questionId, question);
      }
    }

    return [...questionMap.values()]?.map((question, index) => (
      <div className="competenacy-tracker-card" key={question?.id}>
        <p>
          <div className="dotse"></div>
          {t(`View Details.Question`)} {index + 1}{" "}
          {question?.competencies?.length && (
            <>
              <span>({question?.competencies?.join(", ")})</span>{" "}
            </>
          )}
          <span>{question?.questionWeightage || 0} Marks</span>
        </p>
        <h3>{question?.question}</h3>

        <div className="competacy-answear-card">
          <div className="competacy-answear-card-content">
            <p>
              {question?.answerValue
                ? t(`View Details.Your answer`) + ": " + question?.answerValue
                : t(`View Details.No answer provided`)}
            </p>
          </div>
          <span>
            <img
              src={question?.isAnsCorrect ? check_green : cross_icon}
              alt={question?.isAnsCorrect ? "check" : "cross"}
            />
          </span>
        </div>
      </div>
    ));
  };

  const handleCopyExamUrl = async () => {
    const examUrl = candidateDetails?.exam_url;

    if (!examUrl) {
      toast.error("Exam URL is not available");
      return;
    }

    try {
      await navigator.clipboard.writeText(examUrl);
      toast.success("Exam URL copied successfully!");
    } catch (error) {
      console.error("Failed to copy Exam URL:", error);
      toast.error("Failed to copy Exam URL");
    }
  };

  // Calculate and set the competency scores
  useEffect(() => {
    const scores = calculateCompetencyScores();
    setScreeningTestScore(scores);
  }, [selectedOption, selectedInterviewerOption]);

  const printRef = useRef(); // Create a ref to hold the content to print

  const handlePrint = () => {
    const contentToPrint = printRef.current.innerHTML;
    const originalContent = document.body.innerHTML;

    // Set the page content to the content you want to print
    document.body.innerHTML = contentToPrint;

    window.print();

    // After printing, restore the original content of the page
    document.body.innerHTML = originalContent;
    window.location.reload(); // Reload to reset any lost state (optional)
  };

  if (!checkPermissionStatus("candidate-consolidate", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`View Details.Access Denied`)}</h4>
      </div>
    );
  }

  // console.log(JSON.stringify(timelineUpdates), "timelineUpdates");

  return (
    <>
      {/* Banner */}
      <div className="inner-banner job-conslodiate">
        {/* <Container fluid>
          <div className="banner-content text-left  border-bottom py-2">
            <Col sm="6">
              <h5 className="text-uppercase heading-one">
                Candidate Consolidated View
              </h5>
            </Col>
          </div>
        </Container> */}
        <div className="joblist-container create-vacancy">
          <Row className="mb-3  py-2 pt-0 depart-content">
            <Col lg="6" md="6">
              <h5 className="text-uppercase heading-one">
                <img
                  src={arrow_btn}
                  alt="arrow_btn"
                  className="arrow-btn"
                  onClick={handleClick}
                />
                {t("View Details.Candidate Consolidated View")}-{" "}
                {candidateDetails?.vacancy?.title}
              </h5>

              {/* </Link> */}
            </Col>
            <Col lg="6" md="6">
              <div className="d-flex justify-content-end gap-3">
                <div
                  title={
                    isCandidateSelected
                      ? "Candidate is already selected"
                      : "Change Position"
                  }
                >
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleChangePosition}
                    disabled={isCandidateSelected}
                  >
                    {isCandidateSelected
                      ? "Candidate Selected"
                      : "Change Position"}
                  </button>
                </div>

                <Button
                  className="btn btn-primary mt-0"
                  onClick={handleViewReport}
                >
                  {t(`View Details.Print Report`)}
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <div className="outerTab-box-wrapper below-vacancy">
        <div className="cards-section cadidate-details mt-2">
          <>
            <div className="card-header pb-0 d-flex justify-content-between">
              <h2 className="h4">
                {t(`View Details.Personal Details`)}{" "}
                {getSubdomain() !== "mahindra" && (
                  <span className="start-icons">
                    {" "}
                    <FontAwesomeIcon
                      icon={faStar}
                      style={{ cursor: "pointer", color: "#FEAE44" }}
                    />{" "}
                    {averageScore || 0}{" "}
                  </span>
                )}
              </h2>
              <div>
                {checkPermissionStatus("candidate-consolidate", "edit") && (
                  <Link
                    className="text-success blue-icon blue-color4"
                    to={`#`}
                    onClick={() => handleEditUser()}
                    title={t(`View Details.Edit Details`)}
                  >
                    <img src={edit_icon} alt="delete_icon" />
                  </Link>
                )}
              </div>
            </div>

            <div className="card-table-details">
              <div className="personalInfo-details mt-3">
                {candidateDetails?.exam_url != null && (
                  <div className="personal-info">
                    <span>
                      <img src={globe} alt="account" className="globe" />
                    </span>

                    <div className="perosonal-card-info">
                      <h4 style={{ whiteSpace: "nowrap" }}>
                        {t(`View Details.Exam URL`)}:
                      </h4>

                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleCopyExamUrl}
                      >
                        Copy Exam URL
                      </button>
                    </div>
                  </div>
                )}
                <div className="personal-info">
                  <span>
                    <img src={account} alt="account" />
                  </span>
                  <div className="perosonal-card-info">
                    <h4>{t(`View Details.Name`)}:</h4>
                    <span>{candidateDetails?.name}</span>
                  </div>
                </div>

                <div className="personal-info">
                  <span>
                    <img src={email} alt="email" />
                  </span>
                  <div className="perosonal-card-info">
                    <h4>{t(`View Details.Email Id`)}:</h4>
                    <span>
                      <a
                        href={`mailto:${candidateDetails?.email_id || ""}`}
                        title={
                          candidateDetails?.email_id &&
                          candidateDetails.email_id.length > 30
                            ? generateMaskedPII(candidateDetails.email_id)
                            : ""
                        }
                      >
                        {candidateDetails?.email_id &&
                        candidateDetails.email_id.length > 30
                          ? `${generateMaskedPII(
                              candidateDetails.email_id
                            ).slice(0, 30)}...`
                          : generateMaskedPII(candidateDetails?.email_id)}
                      </a>
                      {/* {" "}
                      {candidateDetails?.email_id &&
                      candidateDetails.email_id.length > 30
                        ? `${generateMaskedPII(candidateDetails.email_id).slice(
                            0,
                            30
                          )}...`
                        : generateMaskedPII(candidateDetails?.email_id)}{" "} */}
                    </span>
                  </div>
                </div>
                <div className="personal-info">
                  <span>
                    <img src={mobile} alt="email" />
                  </span>
                  <div className="perosonal-card-info">
                    <h4>{t(`View Details.Mobile No`)}:</h4>
                    <span>
                      <a
                        href={
                          checkPermissionStatus(
                            "personal-id-info",
                            "view_unmasked"
                          )
                            ? `tel:${candidateDetails.mobile}`
                            : null
                        }
                      >
                        {generateMaskedPII(candidateDetails?.mobile, 2)}
                      </a>
                    </span>
                  </div>
                </div>
                <div className="personal-info">
                  <span>
                    <img src={calednder} alt="email" />
                  </span>
                  <div className="perosonal-card-info">
                    <h4>{t("View Details.Date of Birth")}:</h4>
                    <span>
                      {candidateDetails?.job_user?.dob
                        ? moment(
                            getCompanyTimezoneDateTime(
                              candidateDetails.job_user.dob
                            )
                          ).format("DD MMM YYYY")
                        : ""}
                    </span>
                  </div>
                </div>
                <div className="personal-info">
                  <span>
                    <img src={gendre} alt="email" />
                  </span>
                  <div className="perosonal-card-info">
                    <h4>{t(`View Details.Gender`)}:</h4>
                    <span>
                      {
                        candidateDetails?.job_user?.master_reference_table
                          ?.gender
                      }
                    </span>
                  </div>
                </div>
                <div className="personal-info">
                  <span>
                    <img src={education} alt="email" />
                  </span>
                  <div className="perosonal-card-info">
                    <h4>{t(`View Details.Highest Qualification`)}:</h4>
                    <span>
                      {
                        candidateDetails.master_reference_table
                          ?.highest_qualification
                      }
                    </span>
                  </div>
                </div>
                <div className="personal-info">
                  <span>
                    <img src={education} alt="email" />
                  </span>
                  <div className="perosonal-card-info">
                    <h4>{t(`View Details.preferred_city`)}:</h4>
                    <span>{candidateDetails.job_user?.preferred_city}</span>
                  </div>
                </div>
                {resumeUrl &&
                  allowedTypes.includes(fileType?.toLowerCase()) && (
                    <div className="personal-info">
                      <span>
                        <img src={resume} alt="resume" />
                      </span>
                      <div className="personal-card-info">
                        <h4 className="pb-0 mb-0">
                          {t(`View Details.Resume`)}:
                        </h4>
                        <div className="info-icon">
                          <span>
                            <img src={info_icon} alt="" />
                          </span>

                          <p>
                            {t(`View Details.Click here to view candidate CV`)}
                          </p>
                        </div>

                        <button
                          className="btn btn-primary"
                          onClick={() =>
                            window.open(
                              resumeUrl,
                              "_blank",
                              "noopener,noreferrer"
                            )
                          }
                        >
                          <span>{t(`View Details.View Resume`)}</span>
                        </button>
                      </div>
                    </div>
                  )}

                <ModalView
                  isOpen={isModalOpen}
                  onClose={handleCloseModal}
                  resumeUrl={resumeUrl}
                  fileType={fileType}
                />

                {/* {getSubdomain() !== "mahindra" && resumeUrl && (
                  <div className="personal-info">
                    {isCVBuild === 1 ? (
                      <>
                        {" "}
                        <span>
                          <img src={resume} alt="resume" />
                        </span>
                        <div className="personal-card-info">
                          <h4 className="pb-0 mb-0">
                            {t(`View Details.Resume`)}:{" "}
                          </h4>
                          <div className="info-icon">
                            <span>
                              <img src={info_icon} alt="" />
                            </span>

                            <p>
                              {t(
                                `View Details.Click here to download candidate CV effortlessly`
                              )}
                            </p>
                          </div>
                          <button
                            className="btn btn-primary"
                            onClick={handleDownloadResume}
                          >
                            <span>{t(`View Details.Download Resume`)}</span>
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <span>
                          <img src={resume} alt="resume" />
                        </span>
                        <div className="personal-card-info">
                          {!resumeGenerated && (
                            <>
                              <h4 className="pb-0 mb-0">
                                {t(`View Details.Resume`)}:
                              </h4>
                              <div className="info-icon">
                                <span>
                                  <img src={info_icon} alt="" />
                                </span>

                                <p>
                                  {t(
                                    `View Details.Click here to build candidate CV effortlessly`
                                  )}
                                </p>
                              </div>
                              <button
                                className="btn btn-primary"
                                onClick={handleFileUpload}
                                disabled={loading}
                              >
                                <span>
                                  {loading
                                    ? t(`View Details.Building`)
                                    : t(`View Details.CV Build`)}
                                </span>
                              </button>
                            </>
                          )}

                        
                          {loading && (
                            <div className="loading-indicator">
                              {t(`View Details.Generating resume, please wait`)}
                            </div>
                          )}

                        
                          {!loading && resumeGenerated && (
                            <>
                              <h4 className="pb-0 mb-0">
                                {t(`View Details.Resume`)}:
                              </h4>
                              <div className="info-icon">
                                <span>
                                  <img src={info_icon} alt="" />
                                </span>
                              </div>
                              <button
                                className="btn btn-primary"
                                onClick={handleDownloadResume}
                              >
                                <span>{t(`View Details.Download Resume`)}</span>
                              </button>
                            </>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                )} */}

                <div className="personal-info">
                  <span>
                    <img src={score} alt="resume" />
                  </span>
                  <div className="perosonal-card-info">
                    <h4>{t(`View Details.Relevancy Score`)}</h4>
                    <span>
                      {" "}
                      {Math.round(candidateDetails?.relevancy_score || 0)}%
                    </span>{" "}
                  </div>
                </div>

                {/* <div className="personal-info">
                  <div className="perosonal-card-info">
                    <h4>
                      <Link to="/import-resume-user">Resume Import</Link>
                    </h4>
                  </div>
                </div> */}

                {referred && Object.keys(referred).length > 0 && (
                  <div className="personal-info">
                    <span>
                      <img src={referred_by} alt="resume" />
                    </span>
                    <div className="perosonal-card-info">
                      <h4> {t(`View Details.Referred by`)}</h4>
                      <span>
                        {" "}
                        {referred.ref_emp_name} ({t(`View Details.Employee ID`)}
                        : {referred.ref_emp_id})
                      </span>{" "}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </>
        </div>
        <div className="view-details-cards">
          <button className="arrow-btns" onClick={scrollLeft}>
            <img src={right_arrow} alt="right-arrow" />
          </button>
          <button className="arrow-btns right" onClick={scrollRight}>
            <img src={right_arrow} alt="right-arrow" />
          </button>

          <ul
            className="mb-3 nav nav-tabs"
            ref={tabWrapperRef}
            style={{ transition: "transform 0.3s" }}
          >
            <li className="nav-item">
              <button
                type="button"
                onClick={() => handleTabClick("application")}
                className={`nav-link ${
                  activeTab === "application" ? "active" : ""
                }`}
              >
                {t(`View Details.Application Details`)}
              </button>
            </li>
            <li className="nav-item">
              <button
                type="button"
                onClick={() => handleTabClick("degrees")}
                className={`nav-link ${
                  activeTab === "degrees" ? "active" : ""
                }`}
              >
                {t(`View Details.Degrees & Certificates`)}
              </button>
            </li>
            {getSubdomain() === "mahindra" &&
              checkPermissionStatus("preassessment-list", "view") && (
                <li className="nav-item">
                  <button
                    type="button"
                    onClick={() => handleTabClick("preassessment")}
                    className={`nav-link ${
                      activeTab === "preassessment" ? "active" : ""
                    }`}
                  >
                    {t(`View Details.PreAssessmentQuestions`)}
                  </button>
                </li>
              )}
            {getSubdomain() !== "mahindra" && (
              <>
                {" "}
                <li className="nav-item">
                  <button
                    type="button"
                    onClick={() => handleTabClick("behavioral")}
                    className={`nav-link ${
                      activeTab === "behavioral" ? "active" : ""
                    }`}
                  >
                    {t(`View Details.Behavioral Analysis`)}
                  </button>
                </li>
                {/* <li className="nav-item">
                  <button
                    type="button"
                    onClick={() => handleTabClick("interviewerfeedback")}
                    className={`nav-link ${
                      activeTab === "interviewerfeedback" ? "active" : ""
                    }`}
                  >
                    Interviewerfeedback Test Analysis
                  </button>
                </li> */}
                {/* <li className="nav-item">
                  <button
                    type="button"
                    onClick={() => handleTabClick("communication")}
                    className={`nav-link ${
                      activeTab === "communication" ? "active" : ""
                    }`}
                  >
                    {t(`View Details.Communication Logs`)}
                  </button>
                </li> */}
              </>
            )}
            <li className="nav-item">
              <button
                type="button"
                onClick={() => handleTabClick("screening")}
                className={`nav-link ${
                  activeTab === "screening" ? "active" : ""
                }`}
              >
                {t(`View Details.Screening Test Analysis`)}
              </button>
            </li>
            <li className="nav-item">
              <button
                type="button"
                onClick={() => handleTabClick("feedbacks")}
                className={`nav-link ${
                  activeTab === "feedbacks" ? "active" : ""
                }`}
              >
                {t(`View Details.Feedbacks & Rating`)}
              </button>
            </li>
            <li className="nav-item">
              <button
                type="button"
                onClick={() => handleTabClick("notes")}
                className={`nav-link ${activeTab === "notes" ? "active" : ""}`}
              >
                {t(`View Details.Notes`)}
              </button>
            </li>
            <li className="nav-item">
              <button
                type="button"
                onClick={() => handleTabClick("comments")}
                className={`nav-link ${
                  activeTab === "comments" ? "active" : ""
                }`}
              >
                {t(`View Details.comment`)}
              </button>
            </li>
          </ul>

          <div className="tab-content">
            {activeTab === "application" && (
              <>
                <div className="row mt-4">
                  <div className="col-md-12">
                    <div className="cards-section cadidate-details cardshadow paragrcontent mt-2">
                      <div className="card-header">
                        {/* <h2 className="h4">Application Details</h2> */}
                        <h2 className="h4">{t(`View Details.Overview`)}</h2>
                      </div>

                      <div className="card-table-details tabel-application table-responsive ">
                        <ul className="application-details-card">
                          <li>
                            <div class="application-tracker green-card">
                              <h3>{t(`View Details.Application Number`)}: </h3>
                              <p>
                                {candidateDetails.appl_id}/
                                {moment(
                                  getCompanyTimezoneDateTime(
                                    candidateDetails.apply_date
                                  )
                                ).format("MYYYY")}
                              </p>
                            </div>
                          </li>

                          {/* <li>
                            <div class="application-tracker green-card">
                              <h3>{t(`View Details.Date`)}:</h3>
                              <p>
                                {moment(
                                  getCompanyTimezoneDateTime(
                                    candidateDetails.apply_date
                                  )
                                ).format("DD MMM YYYY")}
                              </p>
                            </div>
                          </li> */}

                          <li>
                            <div class="application-tracker green-card">
                              <h3>{t(`View Details.Application Date`)}:</h3>
                              <p>
                                {moment(
                                  getCompanyTimezoneDateTime(
                                    candidateDetails.apply_date
                                  )
                                ).format("DD MMM YYYY")}
                              </p>
                            </div>
                          </li>
                          <li>
                            <div class="application-tracker green-card">
                              <h3>{t(`View Details.Total Experience`)}:</h3>
                              <p>
                                {candidateDetails.job_user?.total_experience}{" "}
                                {t(`View Details.Years`)}
                              </p>
                            </div>
                          </li>
                          <li>
                            <div class="application-tracker green-card">
                              <h3>{t(`View Details.expected_salary`)}:</h3>
                              <p>
                                {candidateDetails?.expected_salary
                                  ? `₹${Number(
                                      candidateDetails.expected_salary
                                    ).toLocaleString("en-IN")}`
                                  : "-"}
                              </p>
                            </div>
                          </li>
                          <li>
                            <div class="application-tracker green-card">
                              <h3>{t(`View Details.aadhaar_verification`)}:</h3>
                              <p
                                className={
                                  candidateDetails?.job_user?.aadhaar_verified
                                    ? "text-success"
                                    : "text-warning"
                                }
                              >
                                {candidateDetails?.job_user?.aadhaar_verified
                                  ? "Verified"
                                  : "Pending"}
                              </p>
                            </div>
                          </li>

                          <li>
                            <div class="application-tracker green-card">
                              <h3>{t(`View Details.bank_verification`)}:</h3>
                              <p
                                className={
                                  candidateDetails?.job_user?.bank_verified
                                    ? "text-success"
                                    : "text-warning"
                                }
                              >
                                {candidateDetails?.job_user?.bank_verified
                                  ? "Verified"
                                  : "Pending"}
                              </p>
                            </div>
                          </li>

                          <li>
                            <div class="application-tracker green-card">
                              <h3>
                                {t(`View Details.background_verification`)}:
                              </h3>
                              <p
                                className={
                                  candidateDetails?.job_user
                                    ?.background_verified
                                    ? "text-success"
                                    : "text-warning"
                                }
                              >
                                {candidateDetails?.job_user?.background_verified
                                  ? "Verified"
                                  : "Pending"}
                              </p>
                            </div>
                          </li>
                          {getSubdomain() !== "mahindra" && (
                            <li>
                              <div class="application-tracker green-card">
                                <h3>{t(`View Details.City`)}:</h3>
                                <p>{candidateDetails.master_city?.city}</p>
                              </div>
                            </li>
                          )}
                        </ul>

                        <div className=" react-bootstrap-table d-none">
                          <table className="table table-bordered table-striped table-responsive">
                            <tbody>
                              <tr>
                                <td width={350}>
                                  <span className="fw-bold applicat-ca">
                                    {t(`View Details.Application Number`)}:
                                  </span>
                                </td>
                                <td>
                                  <p>
                                    {candidateDetails.appl_id}/
                                    {moment(
                                      getCompanyTimezoneDateTime(
                                        candidateDetails.apply_date
                                      )
                                    ).format("MYYYY")}
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td width={350}>
                                  <span className="fw-bold applicat-ca">
                                    {t(`View Details.Date`)}:
                                  </span>
                                </td>
                                <td>
                                  <p>
                                    {moment(
                                      getCompanyTimezoneDateTime(
                                        candidateDetails.apply_date
                                      )
                                    ).format("DD MMM YYYY")}
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td width={350}>
                                  <span className="fw-bold applicat-ca">
                                    {t(`View Details.Application Date`)}:
                                  </span>
                                </td>
                                <td>
                                  <p>
                                    {moment(
                                      getCompanyTimezoneDateTime(
                                        candidateDetails.apply_date
                                      )
                                    ).format("DD MMM YYYY")}
                                  </p>
                                </td>
                              </tr>

                              <tr>
                                <td width={350}>
                                  <span className="fw-bold applicat-ca">
                                    {t(`View Details.Total Experience`)}
                                  </span>
                                </td>
                                <td>
                                  <p>
                                    {
                                      candidateDetails.job_user
                                        ?.total_experience
                                    }{" "}
                                    {t(`View Details.Years`)}
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td width={350}>
                                  <span className="fw-bold applicat-ca">
                                    {t(`View Details.City`)}
                                  </span>
                                </td>
                                <td>
                                  <p>{candidateDetails.master_city?.city}</p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 paragrcontent-anay">
                    <div className="cards-section cadidate-details cardshadow paragrcontent ApplicationTracker mt-2">
                      <div className="card-header">
                        <h2 className="h4 mb-1">
                          {t(`View Details.Application Tracker`)}
                        </h2>
                      </div>

                      <div className="card-table-details tabel-application table-responsive">
                        <ul>
                          {trackerValues?.map((el, index) => {
                            const isGreyCard =
                              el?.stage >= candidateDetails?.currentStage;

                            return (
                              <li
                                key={index}
                                className={`green-card ${
                                  isGreyCard ? "grey-card" : ""
                                }`}
                              >
                                <div
                                  className={`application-tracker ${
                                    isGreyCard ? "grey-card" : "green-card"
                                  }`}
                                >
                                  <div className="sucess-img">
                                    {/* Only show the green icon if it's not a grey card */}
                                    {isGreyCard ? (
                                      <span className="grey-s">
                                        <img
                                          src={cricle_check_gry}
                                          alt="grey icon"
                                        />
                                      </span>
                                    ) : (
                                      <span className="green-s">
                                        <img
                                          src={cricle_check}
                                          alt="green icon"
                                        />
                                      </span>
                                    )}
                                  </div>
                                  <h3>
                                    {el?.title}{" "}
                                    {el?.roundStatus ? (
                                      <small className="text-muted">
                                        [{el?.roundStatus}]
                                      </small>
                                    ) : (
                                      ""
                                    )}{" "}
                                  </h3>
                                  <p>
                                    {el?.date
                                      ? moment(
                                          getCompanyTimezoneDateTime(el?.date)
                                        ).format("Do MMM, YYYY")
                                      : ""}
                                  </p>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 paragrcontent-anay">
                    <div className="cards-section cadidate-details cardshadow paragrcontent mt-2">
                      <div className="card-header">
                        <h2 className="h4 mb-2">
                          {t(`View Details.Timeline Updates`)}
                        </h2>
                      </div>

                      <div className="round-card viewdetails-card">
                        <div class="selected-round available-round w-100">
                          <div class="d-flex align-items-center gap-3  four-rounds-ca">
                            <div class="green-card-round">
                              <h5>
                                <img src={cricle_check} alt="green icon" />
                              </h5>
                            </div>
                            <div>
                              <h4>
                                {candidateDetails?.job_user?.name + " "}
                                {t(`View Details.applied for position of`)}
                                {" " + candidateDetails?.vacancy?.title}
                              </h4>
                              <p>
                                {t(`View Details.on`)}{" "}
                                {moment(
                                  getCompanyTimezoneDateTime(
                                    candidateDetails?.createdAt
                                  )
                                ).format("Do MMM'YYYY hh:mm a")}
                                .
                              </p>
                            </div>
                          </div>
                        </div>
                        {timelineUpdates?.length > 0 &&
                          timelineUpdates.map(el => {
                            return (
                              <div class="selected-round available-round w-100">
                                <div class="d-flex align-items-center gap-3 four-rounds-ca">
                                  <div class="green-card-round">
                                    <h5>
                                      <img
                                        src={cricle_check}
                                        alt="green icon"
                                      />
                                    </h5>
                                  </div>

                                  <div>
                                    <h4>
                                      {el?.action === "Job Status Updated" && (
                                        <>
                                          {el?.action} {t(`View Details.from`)}{" "}
                                          {el?.old_status}{" "}
                                          {t(`View Details.to`)}{" "}
                                          {el?.new_status}
                                        </>
                                      )}
                                    </h4>

                                    <p>
                                      {t(`View Details.on`)}{" "}
                                      {moment(
                                        getCompanyTimezoneDateTime(
                                          el?.createdAt
                                        )
                                      ).format("Do MMM'YYYY hh:mm a")}
                                      .
                                    </p>

                                    {/* ✅ JOB COMMENTS */}
                                    {el?.job_comments?.length > 0 &&
                                      el.job_comments.map((jc, index) => (
                                        <p key={index}>{jc.comment}</p>
                                      ))}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {
              // checkPermissionStatus("candidate-consolidate", "documents") &&
              <>
                {activeTab === "degrees" && (
                  <div>
                    <div className="row mt-4">
                      <div className="col-md-12">
                        {/* Directly displaying work permit information */}
                        <div className="cards-section cadidate-details details-voter mt-4">
                          <h5
                            className="d-flex gap-2 align-items-center"
                            style={{
                              fontWeight: "normal",
                              marginBottom: "20px",
                            }}
                          >
                            {t(`View Details.Work Permit Document`)}
                          </h5>
                          <p className="pdf-details">
                            {candidateDetails?.job_user
                              ?.work_permit_document ? (
                              <span className="d-flex align-items-center">
                                <span style={{ marginLeft: "5px" }}>
                                  {t(`View Details.Document`)}
                                  {!checkPermissionStatus(
                                    "personal-id-info",
                                    "view_unmasked"
                                  ) ? (
                                    <>
                                      {" "}
                                      <FontAwesomeIcon
                                        icon={faLock}
                                        title="You are not authorized to view this document"
                                      />
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </span>{" "}
                                <FontAwesomeIcon
                                  className="mx-1"
                                  icon={faImages}
                                  style={{ cursor: "pointer" }}
                                  width={"25px"}
                                  height={"25px"}
                                  onClick={() =>
                                    !checkPermissionStatus(
                                      "personal-id-info",
                                      "view_unmasked"
                                    )
                                      ? null
                                      : handleAttachmentOpen2()
                                  }
                                />{" "}
                                {/* Added Document text here */}
                              </span>
                            ) : (
                              <span style={{ fontSize: "0.875rem" }}>
                                {t(`View Details.No Details Available`)}
                              </span>
                            )}
                          </p>
                        </div>

                        <div className="cards-section cadidate-details details-voter mt-2">
                          <VoterDetails
                            data={documentData?.voterDetails || ""}
                            user_id={candidateDetails?.user_id}
                            appl_id={appl_id}
                            onSubmit={onSubmit}
                          />
                        </div>
                        <div className="cards-section cadidate-details details-voter mt-4">
                          <DrivingLicense
                            data={documentData?.drivingDetails || ""}
                            user_id={candidateDetails?.user_id}
                            appl_id={appl_id}
                            onSubmit={onSubmit}
                          />
                        </div>
                        <div className="cards-section cadidate-details details-voter mt-4">
                          <PassportDetails
                            data={documentData?.passportDetails || ""}
                            user_id={candidateDetails?.user_id}
                            appl_id={appl_id}
                            onSubmit={onSubmit}
                          />
                        </div>
                        <div className="cards-section cadidate-details details-voter mt-4">
                          <PreviousExperience
                            data={documentData?.previousExpDetails || ""}
                            user_id={candidateDetails?.user_id}
                            appl_id={appl_id}
                            onSubmit={onSubmit}
                          />
                        </div>
                        <div className="cards-section cadidate-details details-voter mt-4">
                          <DegreesCertificates
                            data={documentData?.degreeDetails || ""}
                            user_id={candidateDetails?.user_id}
                            appl_id={appl_id}
                            onSubmit={onSubmit}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            }

            <>
              {questionsData?.length > 0 && activeTab === "preassessment" && (
                <>
                  {/* PRE-ASSESSMENT TAB CONTENT */}

                  {isPreAssessmentSubmitted && (
                    <div className="alert alert-success mb-3">
                      ✅ <strong>Pre-Assessment Completed</strong>
                      <br />
                      <h4>
                        Score:{" "}
                        {candidateScore !== null ? `${candidateScore}%` : "N/A"}
                      </h4>
                    </div>
                  )}
                  <PreAssessmentQuestions
                    questions={questionsData || []}
                    answers={answerData}
                    setAnswers={setAnswerData}
                    isSubmitted={isPreAssessmentSubmitted}
                  />
                  {!isPreAssessmentSubmitted &&
                    checkPermissionStatus("preassessment-list", "create") && (
                      <button
                        type="button"
                        onClick={handleSubmitPermit}
                        className="btn btn-primary"
                        disabled={isPreAssessmentSubmitting}
                      >
                        {isPreAssessmentSubmitting ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Submitting...
                          </>
                        ) : (
                          t(`Submit`)
                        )}
                      </button>
                    )}
                  {workPermitErrors?.questionError && (
                    <Form.Text className="text-danger">
                      {workPermitErrors?.questionError}
                    </Form.Text>
                  )}
                </>
              )}
            </>

            <>
              {questionsData?.length === 0 && activeTab === "preassessment" && (
                <div className="alert-card pt-4">
                  <div className="no-data data-available">
                    <img
                      src="../../img/data-not-available.png"
                      alt="data not available"
                    />
                    <h3>{t(`View Details.No Item Found`)}</h3>
                    <p>
                      {t(`View Details.Sorry, we could not find any`)} <br />
                      {t(`View Details.Item to show here`)}
                    </p>
                  </div>
                </div>
              )}
            </>

            {activeTab === "behavioral" && (
              <div>
                {santimentDetails?.enthusiastic ||
                santimentDetails?.engaging ||
                santimentDetails?.positive ||
                santimentDetails?.negative ||
                santimentDetails?.aws_neutral ? (
                  <div className="row mt-1">
                    {candidateDetails.hiring_assessments?.questions_value && (
                      <div className="col-xl-6 col-lg-12 martin-space-top mt-2">
                        <div className="cards-section cadidate-details cardshadow mt-0">
                          <>
                            <div className="card-header">
                              <div className="personal-heading">
                                <h2 className="h4 heading-two mb-1">
                                  {t(`View Details.Score Details`)}:{" "}
                                  <span>
                                    {assessmentScore.compt_avg_per}%
                                    {assessmentScore.compt_avg_per < 40 ? (
                                      <span style={{ color: "red" }}>
                                        {" "}
                                        ( {t(`View Details.Fail`)}){" "}
                                      </span>
                                    ) : (
                                      <span style={{ color: "green" }}>
                                        {" "}
                                        ( {t(`View Details.Pass`)}){" "}
                                      </span>
                                    )}
                                  </span>
                                  <span></span>
                                </h2>
                              </div>
                            </div>

                            <div className="card-table-details tabel-application table-responsive ">
                              <div className=" react-bootstrap-table">
                                <table className="table table-bordered table-striped table-responsive">
                                  <tbody>
                                    {Object.entries(assessmentScore).map(
                                      ([key_, value_], index_) => (
                                        <tr key={index_}>
                                          <td width={200}>
                                            <span className="fw-bold">
                                              {competencyData[key_]}
                                            </span>
                                          </td>

                                          {/* Render ProgressBar for each competency */}
                                          <td>
                                            {typeof value_ === "object" &&
                                            value_.per !== undefined ? (
                                              <ProgressBar
                                                variant="success"
                                                now={value_.per || 0}
                                                label={`${value_.per || 0}%`}
                                                width="100"
                                              />
                                            ) : (
                                              <span></span>
                                            )}
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </>
                        </div>
                      </div>
                    )}

                    {/* BehaviouralScore Sepration */}

                    {santimentDetails?.transcript && (
                      <div className="col-xl-6 col-lg-12 behrviroual-cardss">
                        <>
                          <div className="cards-section cadidate-details cardshadow paragrcontent behrviroual-score-card d-flex  mt-2">
                            <div className="card-table-details tonality tabel-application table-responsive ">
                              <div className="card-header">
                                <h2 className="h4 mb-1">
                                  {" "}
                                  {t(`View Details.Behavioural Score`)}
                                </h2>
                              </div>
                              <div
                                className="progress-chart-table behaviour-list"
                                key="emo"
                              >
                                <div className="progress-children-chart">
                                  <CircularProgressbarWithChildren
                                    value={santimentDetails?.behavioural_score}
                                    styles={buildStyles({
                                      pathColor: "#556ee6",
                                      trailColor: "#eee",
                                      strokeLinecap: "butt",
                                    })}
                                  >
                                    <div
                                      className="progress-bar-styles"
                                      style={{
                                        fontSize: 12,
                                        color: "#556ee6",
                                      }}
                                    >
                                      <h5
                                        className="pb-1"
                                        style={{
                                          fontSize: 12,
                                          color: "#556ee6",
                                          fontWeight: "bold",
                                          opacity: 1,
                                        }}
                                      >
                                        {t(`View Details.Behavioural Score`)}
                                      </h5>
                                      <strong>
                                        {Math.round(
                                          santimentDetails?.behavioural_score ||
                                            0
                                        )}
                                        %
                                      </strong>{" "}
                                    </div>
                                  </CircularProgressbarWithChildren>
                                </div>
                              </div>
                            </div>

                            <div className="card-table-details tonality tabel-application table-responsive ">
                              <div className="card-header">
                                <h2 className="h4 mb-1">
                                  {t(`View Details.Attentive Score`)}{" "}
                                </h2>
                              </div>
                              <div
                                className="progress-chart-table behaviour-list"
                                key="emo"
                              >
                                <div className="progress-children-chart">
                                  <CircularProgressbarWithChildren
                                    value={santimentDetails?.attention_score}
                                    styles={buildStyles({
                                      pathColor: "#34C38F",
                                      trailColor: "#eee",
                                      strokeLinecap: "butt",
                                    })}
                                  >
                                    <div
                                      className="progress-bar-styles"
                                      style={{
                                        fontSize: 12,
                                        color: "#34C38F",
                                      }}
                                    >
                                      <h5
                                        className="pb-1"
                                        style={{
                                          fontSize: 12,
                                          color: "#34C38F",
                                          fontWeight: "bold",
                                          opacity: 1,
                                        }}
                                      >
                                        {t(`View Details.Attentive Score`)}
                                      </h5>
                                      <strong>
                                        {Math.round(
                                          santimentDetails?.attention_score || 0
                                        )}
                                        %
                                      </strong>{" "}
                                    </div>
                                  </CircularProgressbarWithChildren>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    )}

                    {/* TRANSSCRIPT AND VIDE PLAY SECTION */}

                    {santimentDetails?.transcript && (
                      <div className="col-xl-6 col-lg-12 paragrcontent-anays">
                        <div className="cards-section cadidate-details cardshadow paragrcontent mt-2">
                          <>
                            <div className="card-header d-flex align-items-center justify-content-between">
                              <h2 className="h3">
                                {t(`View Details.Transcript`)}
                              </h2>
                            </div>
                            <div className="card-table-details tabel-application table-responsive ">
                              <p>{santimentDetails?.transcript}</p>
                              <div className="single-filter-box btn-left">
                                <Button
                                  onClick={() =>
                                    toggleVideoPopup(candidateDetails?.video)
                                  }
                                >
                                  <img src={video_play} alt="video play" />
                                  {t(`View Details.View Test Recording`)}
                                </Button>
                              </div>
                            </div>
                          </>
                        </div>
                      </div>
                    )}

                    {/* TRANSSCRIPT BASED ANALYSIS */}

                    <div className="col-xl-4 col-lg-6  paragrcontent-anay">
                      <div className="cards-section cadidate-details cardshadow paragrcontent mt-2">
                        <div className="card-header">
                          <h2 className="h4 mb-1">
                            {t(`View Details.Transcript Based Analysis`)}:{" "}
                          </h2>
                        </div>

                        <div className="card-table-details tonality tabel-application table-responsive ">
                          <div
                            className="progress-chart-table Transcript"
                            key="emo"
                          >
                            <div className="progress-children-chart">
                              <CircularProgressbarWithChildren
                                value={santimentDetails?.enthusiastic}
                                styles={buildStyles({
                                  pathColor: "#047DD6",
                                  trailColor: "#eee",
                                  strokeLinecap: "butt",
                                })}
                              >
                                <div
                                  style={{
                                    fontSize: 14,
                                    marginTop: -5,
                                    color: "#047DD6",
                                  }}
                                >
                                  <strong>
                                    {Math.round(
                                      santimentDetails?.enthusiastic || 0
                                    ) + " %"}
                                  </strong>{" "}
                                </div>
                              </CircularProgressbarWithChildren>
                              <h5> {t(`View Details.Enthusiastic`)}</h5>
                            </div>

                            <div className="progress-children-chart">
                              <CircularProgressbarWithChildren
                                value={santimentDetails?.engaging}
                                styles={buildStyles({
                                  pathColor: "#FFBB44",
                                  trailColor: "#eee",
                                  strokeLinecap: "butt",
                                })}
                              >
                                <div
                                  style={{
                                    fontSize: 14,
                                    marginTop: -5,
                                    color: "#FFBB44",
                                  }}
                                >
                                  <strong>
                                    {Math.round(
                                      santimentDetails?.engaging || 0
                                    )}{" "}
                                    %
                                  </strong>{" "}
                                </div>
                              </CircularProgressbarWithChildren>
                              <h5>{t(`View Details.Engaging`)}</h5>
                            </div>

                            <div className="progress-children-chart">
                              <CircularProgressbarWithChildren
                                value={santimentDetails?.positive}
                                styles={buildStyles({
                                  pathColor: "#67B6DB",
                                  trailColor: "#eee",
                                  strokeLinecap: "butt",
                                })}
                              >
                                <div
                                  style={{
                                    fontSize: 14,
                                    marginTop: -5,
                                    color: "#67B6DB",
                                  }}
                                >
                                  <strong>
                                    {" "}
                                    {Math.round(
                                      santimentDetails?.positive || 0
                                    )}{" "}
                                    %
                                  </strong>{" "}
                                </div>
                              </CircularProgressbarWithChildren>
                              <h5>{t(`View Details.Positive`)}</h5>
                            </div>

                            <div className="progress-children-chart">
                              <CircularProgressbarWithChildren
                                value={santimentDetails?.negative || 0}
                                styles={buildStyles({
                                  pathColor: "#4AC18E",
                                  trailColor: "#eee",
                                  strokeLinecap: "butt",
                                })}
                              >
                                <div
                                  style={{
                                    fontSize: 14,
                                    marginTop: -5,
                                    color: "#4AC18E",
                                  }}
                                >
                                  <strong>
                                    {" "}
                                    {Math.round(
                                      santimentDetails?.negative || 0
                                    )}{" "}
                                    %
                                  </strong>{" "}
                                </div>
                              </CircularProgressbarWithChildren>
                              <h5>{t(`View Details.Negative`)}</h5>
                            </div>

                            <div className="progress-children-chart">
                              <CircularProgressbarWithChildren
                                value={santimentDetails?.aws_neutral}
                                styles={buildStyles({
                                  pathColor: "#F46A6A",
                                  trailColor: "#eee",
                                  strokeLinecap: "butt",
                                })}
                              >
                                <div
                                  style={{
                                    fontSize: 14,
                                    marginTop: -5,
                                    color: "#F46A6A",
                                  }}
                                >
                                  <strong>
                                    {Math.round(
                                      santimentDetails?.aws_neutral || 0
                                    )}{" "}
                                    %
                                  </strong>{" "}
                                </div>
                              </CircularProgressbarWithChildren>
                              <h5>{t(`View Details.Neutral`)}</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* EXPRESSION BASED ANALYSIS */}

                    <div className="col-xl-4 col-lg-6  paragrcontent-anay">
                      <div className="cards-section cadidate-details cardshadow paragrcontent mt-2">
                        <div className="card-header">
                          <h2 className="h4 mb-1">
                            {t(`View Details.Expression Based Analysis`)}:{" "}
                          </h2>
                        </div>
                        <div className="card-table-details tonality tabel-application table-responsive ">
                          <div
                            className="progress-chart-table Transcript"
                            key="emo"
                          >
                            <div className="progress-children-chart">
                              <CircularProgressbarWithChildren
                                value={santimentDetails?.neutral}
                                styles={buildStyles({
                                  pathColor: "#047DD6",
                                  trailColor: "#eee",
                                  strokeLinecap: "butt",
                                })}
                              >
                                <div
                                  style={{
                                    fontSize: 14,
                                    marginTop: -5,
                                    color: "#047DD6",
                                  }}
                                >
                                  <strong>
                                    {Math.round(
                                      santimentDetails?.neutral || 0
                                    ) + " %"}
                                  </strong>{" "}
                                </div>
                              </CircularProgressbarWithChildren>
                              <h5> {t(`View Details.Neutral`)}</h5>
                            </div>

                            <div className="progress-children-chart">
                              <CircularProgressbarWithChildren
                                value={santimentDetails?.surprised}
                                styles={buildStyles({
                                  pathColor: "#FFBB44",
                                  trailColor: "#eee",
                                  strokeLinecap: "butt",
                                })}
                              >
                                <div
                                  style={{
                                    fontSize: 14,
                                    marginTop: -5,
                                    color: "#FFBB44",
                                  }}
                                >
                                  <strong>
                                    {Math.round(
                                      santimentDetails?.surprised || 0
                                    )}{" "}
                                    %
                                  </strong>{" "}
                                </div>
                              </CircularProgressbarWithChildren>
                              <h5>{t(`View Details.Surprised`)}</h5>
                            </div>

                            <div className="progress-children-chart">
                              <CircularProgressbarWithChildren
                                value={santimentDetails?.confidence}
                                styles={buildStyles({
                                  pathColor: "#67B6DB",
                                  trailColor: "#eee",
                                  strokeLinecap: "butt",
                                })}
                              >
                                <div
                                  style={{
                                    fontSize: 14,
                                    marginTop: -5,
                                    color: "#67B6DB",
                                  }}
                                >
                                  <strong>
                                    {" "}
                                    {Math.round(
                                      santimentDetails?.confidence || 0
                                    )}{" "}
                                    %
                                  </strong>{" "}
                                </div>
                              </CircularProgressbarWithChildren>
                              <h5>{t(`View Details.Happy`)}</h5>
                            </div>

                            <div className="progress-children-chart">
                              <CircularProgressbarWithChildren
                                value={santimentDetails?.confused || 0}
                                styles={buildStyles({
                                  pathColor: "#4AC18E",
                                  trailColor: "#eee",
                                  strokeLinecap: "butt",
                                })}
                              >
                                <div
                                  style={{
                                    fontSize: 14,
                                    marginTop: -5,
                                    color: "#4AC18E",
                                  }}
                                >
                                  <strong>
                                    {" "}
                                    {Math.round(
                                      santimentDetails?.confused || 0
                                    )}{" "}
                                    %
                                  </strong>{" "}
                                </div>
                              </CircularProgressbarWithChildren>
                              <h5>{t(`View Details.Sad`)}</h5>
                            </div>

                            <div className="progress-children-chart">
                              <CircularProgressbarWithChildren
                                value={santimentDetails?.fearful}
                                styles={buildStyles({
                                  pathColor: "#F46A6A",
                                  trailColor: "#eee",
                                  strokeLinecap: "butt",
                                })}
                              >
                                <div
                                  style={{
                                    fontSize: 14,
                                    marginTop: -5,
                                    color: "#F46A6A",
                                  }}
                                >
                                  <strong>
                                    {Math.round(santimentDetails?.fearful || 0)}{" "}
                                    %
                                  </strong>{" "}
                                </div>
                              </CircularProgressbarWithChildren>
                              <h5>{t(`View Details.Nervous`)}</h5>
                            </div>

                            <div className="progress-children-chart">
                              <CircularProgressbarWithChildren
                                value={santimentDetails?.angry}
                                styles={buildStyles({
                                  pathColor: "#7F67DB",
                                  trailColor: "#eee",
                                  strokeLinecap: "butt",
                                })}
                              >
                                <div
                                  style={{
                                    fontSize: 14,
                                    marginTop: -5,
                                    color: "#7F67DB",
                                  }}
                                >
                                  <strong>
                                    {Math.round(santimentDetails?.angry || 0)} %
                                  </strong>{" "}
                                </div>
                              </CircularProgressbarWithChildren>
                              <h5>{t(`View Details.Angry`)}</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* TONALITY BASED ANALYSIS */}

                    {santimentDetails?.audio_data && (
                      <div className="col-xl-4 col-lg-6  paragrcontent-anay">
                        <div className="cards-section cadidate-details cardshadow paragrcontent mt-2">
                          <div className="card-header">
                            <h2 className="h4 mb-1">
                              {t(`View Details.Tonality Based Analysis`)}:{" "}
                            </h2>
                          </div>

                          <div className="card-table-details tonality tabel-application table-responsive ">
                            <div className="progress-chart-table" key="emo">
                              <div className="progress-children-chart">
                                <CircularProgressbarWithChildren
                                  value={santimentDetails?.audio_data?.angry}
                                  styles={buildStyles({
                                    pathColor: "#047DD6",
                                    trailColor: "#eee",
                                    strokeLinecap: "butt",
                                  })}
                                >
                                  <div
                                    style={{
                                      fontSize: 14,
                                      marginTop: -5,
                                      color: "#047DD6",
                                    }}
                                  >
                                    <strong>
                                      {Math.round(
                                        santimentDetails?.audio_data?.angry || 0
                                      )}{" "}
                                      %
                                    </strong>{" "}
                                  </div>
                                </CircularProgressbarWithChildren>
                                <h5>{t(`View Details.Angry`)}</h5>
                              </div>

                              <div className="progress-children-chart">
                                <CircularProgressbarWithChildren
                                  value={santimentDetails?.audio_data?.calm}
                                  styles={buildStyles({
                                    pathColor: "#FFBB44",
                                    trailColor: "#eee",
                                    strokeLinecap: "butt",
                                  })}
                                >
                                  <div
                                    style={{
                                      fontSize: 14,
                                      marginTop: -5,
                                      color: "#FFBB44",
                                    }}
                                  >
                                    <strong>
                                      {Math.round(
                                        santimentDetails?.audio_data?.calm || 0
                                      )}{" "}
                                      %
                                    </strong>{" "}
                                  </div>
                                </CircularProgressbarWithChildren>
                                <h5>{t(`View Details.Calm`)}</h5>
                              </div>

                              <div className="progress-children-chart">
                                <CircularProgressbarWithChildren
                                  value={santimentDetails?.audio_data?.neutral}
                                  styles={buildStyles({
                                    pathColor: "#67B6DB",
                                    trailColor: "#eee",
                                    strokeLinecap: "butt",
                                  })}
                                >
                                  <div
                                    style={{
                                      fontSize: 14,
                                      marginTop: -5,
                                      color: "#67B6DB",
                                    }}
                                  >
                                    <strong>
                                      {" "}
                                      {Math.round(
                                        santimentDetails?.audio_data?.neutral ||
                                          0
                                      )}{" "}
                                      %
                                    </strong>{" "}
                                  </div>
                                </CircularProgressbarWithChildren>
                                <h5>{t(`View Details.Neutral`)}</h5>
                              </div>

                              <div className="progress-children-chart">
                                <CircularProgressbarWithChildren
                                  value={santimentDetails?.audio_data?.happy}
                                  styles={buildStyles({
                                    pathColor: "#4AC18E",
                                    trailColor: "#eee",
                                    strokeLinecap: "butt",
                                  })}
                                >
                                  <div
                                    style={{
                                      fontSize: 14,
                                      marginTop: -5,
                                      color: "#4AC18E",
                                    }}
                                  >
                                    <strong>
                                      {Math.round(
                                        santimentDetails?.audio_data?.happy || 0
                                      )}
                                      %
                                    </strong>{" "}
                                  </div>
                                </CircularProgressbarWithChildren>
                                <h5>{t(`View Details.Happy`)}</h5>
                              </div>

                              <div className="progress-children-chart">
                                <CircularProgressbarWithChildren
                                  value={santimentDetails?.audio_data?.sad}
                                  styles={buildStyles({
                                    pathColor: "#F46A6A",
                                    trailColor: "#eee",
                                    strokeLinecap: "butt",
                                  })}
                                >
                                  <div
                                    style={{
                                      fontSize: 14,
                                      marginTop: -5,
                                      color: "#F46A6A",
                                    }}
                                  >
                                    <strong>
                                      {Math.round(
                                        santimentDetails?.audio_data?.sad || 0
                                      )}{" "}
                                      %
                                    </strong>{" "}
                                  </div>
                                </CircularProgressbarWithChildren>
                                <h5>{t(`View Details.Sad`)}</h5>
                              </div>

                              <div className="progress-children-chart">
                                <CircularProgressbarWithChildren
                                  value={santimentDetails?.audio_data?.surprise}
                                  styles={buildStyles({
                                    pathColor: "#7F67DB",
                                    trailColor: "#eee",
                                    strokeLinecap: "butt",
                                  })}
                                >
                                  <div
                                    style={{
                                      fontSize: 14,
                                      marginTop: -5,
                                      color: "#7F67DB",
                                    }}
                                  >
                                    <strong>
                                      {" "}
                                      {Math.round(
                                        santimentDetails?.audio_data
                                          ?.surprise || 0
                                      )}{" "}
                                      %
                                    </strong>{" "}
                                  </div>
                                </CircularProgressbarWithChildren>
                                <h5>{t(`View Details.Surprised`)}</h5>
                              </div>

                              <div className="progress-children-chart">
                                <CircularProgressbarWithChildren
                                  value={santimentDetails?.audio_data?.fear}
                                  styles={buildStyles({
                                    pathColor: "#C4DB67",
                                    trailColor: "#eee",
                                    strokeLinecap: "butt",
                                  })}
                                >
                                  <div
                                    style={{
                                      fontSize: 14,
                                      marginTop: -5,
                                      color: "#C4DB67",
                                    }}
                                  >
                                    <strong>
                                      {Math.round(
                                        santimentDetails?.audio_data?.fear || 0
                                      )}
                                      %
                                    </strong>{" "}
                                  </div>
                                </CircularProgressbarWithChildren>
                                <h5>{t(`View Details.Fear`)}</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="alert-card pt-4">
                    <div className="no-data data-available">
                      <img
                        src="../../img/data-not-available.png"
                        alt="data not available"
                      />
                      <h3>{t(`View Details.No Item Found`)}</h3>
                      <p>
                        {t(`View Details.Sorry, we could not find any`)} <br />
                        {t(`View Details.Item to show here`)}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            )}

            {activeTab === "screening" && (
              <div>
                <div className="row mt-1" ref={printRef}>
                  <div className="col-md-12 col-lg-12 paragrcontent-anays CompetencyScore drodpwoan">
                    <div className="competency-score-card">
                      <h5>{t(`View Details.Test Result`)}</h5>

                      <div
                        title={
                          selectedOption?.label ||
                          `${t(`View Details.Test Result`)}`
                        }
                      >
                        <Select
                          value={selectedOption}
                          onChange={handleChange}
                          options={options}
                          placeholder={t(`View Details.Select Test`)}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Competency Score Section */}
                  <div className="col-md-12 col-lg-6 paragrcontent-anays CompetencyScore viewdetailsca">
                    <div className="cards-section cadidate-details cardshadow paragrcontent mt-2">
                      <div className="card-header d-flex align-items-center justify-content-between">
                        <h2 className="h3 mb-1">
                          {t(`View Details.Competency Score`)}
                        </h2>
                      </div>
                      <div className="mb-2 view-details-menu Screentest7">
                        {Object.entries(
                          screeningTestScore?.competencyScores
                        ).map(([compId, { score, title }]) => (
                          <div className="key-titile" key={compId}>
                            <div className="text-center">
                              <div className="tile-names">
                                <div className="title-name pb-2">{title}</div>
                              </div>
                              <div className="score-details-section">
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "130px",
                                  }}
                                >
                                  <div
                                    className="circleprogress"
                                    style={{ width: 130, height: 130 }}
                                  >
                                    <CircularProgressbar
                                      value={score}
                                      maxValue={100}
                                      text={`${score}%`}
                                      strokeWidth={8}
                                      styles={buildStyles({
                                        textColor: "#000",
                                        pathColor: "#ff0000", // Red color for the progress bar
                                        trailColor: "#d6d6d6",
                                      })}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 col-lg-6 paragrcontent-anays CompetencyScore">
                    <div className="cards-section cadidate-details cardshadow paragrcontent mt-2">
                      {/* <h2 className="h3 mb-1"></h2> */}
                      <div className="card-header d-flex align-items-center justify-content-between">
                        <h2 className="h3 mb-1">
                          {t(`View Details.Screen Test`)}
                        </h2>
                      </div>

                      <div className="card-table-details tabel-application table-responsive Screentest7">
                        {/* Circular Progress Bar for Test Score */}
                        {screeningTestScore?.totalQuestions > 0 && (
                          <div className="score-details-section">
                            {/* <h4 className="h4 mb-2">Screen test</h4> */}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "130px",
                              }}
                            >
                              <div
                                className="circleprogress"
                                style={{ width: 130, height: 130 }}
                              >
                                <CircularProgressbar
                                  value={screeningTestScore?.overallPercentage}
                                  text={`${Math.round(
                                    screeningTestScore?.overallPercentage
                                  )}%`}
                                  styles={buildStyles({
                                    textColor: "#000",
                                    pathColor: "#ff0000", // Red color for the progress bar
                                    trailColor: "#d6d6d6",
                                  })}
                                />
                              </div>
                            </div>
                            <div
                              className="score-summary mt-2"
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                gap: "5px",
                                flexWrap: "wrap",
                              }}
                            >
                              <p style={{ margin: 0 }}>
                                {t(`View Details.Total Questions`)}:{" "}
                                {screeningTestScore?.totalQuestions}
                              </p>
                              <p style={{ margin: 0 }}>
                                {t(`View Details.Total Marks`)}:{" "}
                                {screeningTestScore?.totalMarks}
                              </p>
                              <p style={{ margin: 0 }}>
                                {t(`View Details.Marks Obtained`)}:{" "}
                                {screeningTestScore?.scoredMarks}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-8 co-md-12">
                    <div className="competancy-question-card">
                      <h5>{t(`View Details.Competency Question`)}</h5>

                      {renderScreenTestQuestion()}
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-12">
                    <div className="competency-tracker-card">
                      <div className="interview-slot">
                        <h5>
                          {t(`View Details.Get PDF of Candidate Responses`)}
                        </h5>
                        <div className="btn-cla">
                          <button
                            onClick={handlePrint}
                            className="btn btn-primary"
                          >
                            {t(`View Details.View Responses`)}
                          </button>
                        </div>

                        <img src={time_slot} alt="" className="interview-img" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "interviewerfeedback" && (
              <div>
                <div className="row mt-1" ref={printRef}>
                  <div className="col-md-12 col-lg-12 paragrcontent-anays CompetencyScore drodpwoan">
                    <div className="competency-score-card">
                      <h5>{t(`View Details.Test Result`)}</h5>

                      <div
                        title={
                          selectedOption?.label ||
                          `${t(`View Details.Test Result`)}`
                        }
                      >
                        <Select
                          value={selectedOption}
                          onChange={handleChange}
                          options={createroundoption(candidateDetails)}
                          placeholder={t(`View Details.Select Test`)}
                        />
                      </div>
                      <div title={selectedOption?.label || `Interviewer`}>
                        <Select
                          value={selectedInterviewerOption}
                          onChange={handleinterviewerChange}
                          options={intervieweropt}
                          placeholder="Select Interviewer"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Competency Score Section */}
                  <div className="col-md-12 col-lg-6 paragrcontent-anays CompetencyScore viewdetailsca">
                    <div className="cards-section cadidate-details cardshadow paragrcontent mt-2">
                      <div className="card-header d-flex align-items-center justify-content-between">
                        <h2 className="h3 mb-1">
                          {t(`View Details.Competency Score`)}
                        </h2>
                      </div>
                      <div className="mb-2 view-details-menu Screentest7">
                        {Object.entries(
                          screeningTestScore?.competencyScores
                        ).map(([compId, { score, title }]) => (
                          <div className="key-titile" key={compId}>
                            <div className="text-center">
                              <div className="tile-names">
                                <div className="title-name pb-2">{title}</div>
                              </div>
                              <div className="score-details-section">
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "130px",
                                  }}
                                >
                                  <div
                                    className="circleprogress"
                                    style={{ width: 130, height: 130 }}
                                  >
                                    <CircularProgressbar
                                      value={score}
                                      maxValue={100}
                                      text={`${score}%`}
                                      strokeWidth={8}
                                      styles={buildStyles({
                                        textColor: "#000",
                                        pathColor: "#ff0000", // Red color for the progress bar
                                        trailColor: "#d6d6d6",
                                      })}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 col-lg-6 paragrcontent-anays CompetencyScore">
                    <div className="cards-section cadidate-details cardshadow paragrcontent mt-2">
                      {/* <h2 className="h3 mb-1"></h2> */}
                      <div className="card-header d-flex align-items-center justify-content-between">
                        <h2 className="h3 mb-1">
                          {t(`View Details.Screen Test`)}
                        </h2>
                      </div>

                      <div className="card-table-details tabel-application table-responsive Screentest7">
                        {/* Circular Progress Bar for Test Score */}
                        {screeningTestScore?.totalQuestions > 0 && (
                          <div className="score-details-section">
                            {/* <h4 className="h4 mb-2">Screen test</h4> */}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "130px",
                              }}
                            >
                              <div
                                className="circleprogress"
                                style={{ width: 130, height: 130 }}
                              >
                                <CircularProgressbar
                                  value={screeningTestScore?.overallPercentage}
                                  text={`${Math.round(
                                    screeningTestScore?.overallPercentage
                                  )}%`}
                                  styles={buildStyles({
                                    textColor: "#000",
                                    pathColor: "#ff0000", // Red color for the progress bar
                                    trailColor: "#d6d6d6",
                                  })}
                                />
                              </div>
                            </div>
                            <div
                              className="score-summary mt-2"
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                gap: "5px",
                                flexWrap: "wrap",
                              }}
                            >
                              <p style={{ margin: 0 }}>
                                {t(`View Details.Total Questions`)}:{" "}
                                {screeningTestScore?.totalQuestions}
                              </p>
                              <p style={{ margin: 0 }}>
                                {t(`View Details.Total Marks`)}:{" "}
                                {screeningTestScore?.totalMarks}
                              </p>
                              <p style={{ margin: 0 }}>
                                {t(`View Details.Marks Obtained`)}:{" "}
                                {screeningTestScore?.scoredMarks}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-8 co-md-12">
                    <div className="competancy-question-card">
                      <h5>{t(`View Details.Competency Question`)}</h5>

                      {Object.entries(
                        JSON.parse(
                          (candidateDetails?.hiring_assessments || []).find(
                            assessment =>
                              assessment.interview_type_id ===
                                selectedOption?.value &&
                              assessment.interviewer_id ===
                                selectedInterviewerOption?.value
                          )?.questions_value || "{}"
                        )?.quest_ids || {}
                      ).map(([compId, questions], compIndex) => {
                        return Object.entries(questions).map(
                          ([questionId, questionData], quesIndex) => {
                            return (
                              <div
                                className="competenacy-tracker-card"
                                key={questionData.id}
                              >
                                <p>
                                  <div className="dotse"></div>
                                  {t(`View Details.Question`)} {questCounter++}{" "}
                                  <span>({competencyData[compId]})</span>
                                  <span>
                                    {Math.max(
                                      questionData.weightage1,
                                      questionData.weightage2,
                                      questionData.weightage3,
                                      questionData.weightage4
                                    )}{" "}
                                    Marks
                                  </span>
                                </p>
                                <h3>{questionData.question}</h3>

                                <div className="competacy-answear-card">
                                  <div className="competacy-answear-card-content">
                                    <p>
                                      {[
                                        "option1",
                                        "option2",
                                        "option3",
                                        "option4",
                                      ].includes(questionData.answerValue)
                                        ? `${t(`View Details.Your answer`)}: ${
                                            questionData[
                                              questionData.answerValue
                                            ]
                                          }`
                                        : questionData.answerValue
                                        ? `${t(`View Details.Your answer`)}: ${
                                            questionData.answerValue
                                          }`
                                        : t(`View Details.No answer provided`)}
                                    </p>
                                  </div>
                                  <span>
                                    <img
                                      src={
                                        questionData.answerValue ===
                                          questionData.answer ||
                                        questionData.answerValue ===
                                          questionData[questionData.answer]
                                          ? check_green
                                          : cross_icon
                                      }
                                      alt={
                                        questionData.answerValue ===
                                        questionData.answer
                                          ? "check"
                                          : "cross"
                                      }
                                    />
                                  </span>
                                </div>
                              </div>
                            );
                          }
                        );
                      })}
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-12">
                    <div className="competency-tracker-card">
                      <div className="interview-slot">
                        <h5>
                          {t(`View Details.Get PDF of Candidate Responses`)}
                        </h5>
                        <div className="btn-cla">
                          <button
                            onClick={handlePrint}
                            className="btn btn-primary"
                          >
                            {t(`View Details.View Responses`)}
                          </button>
                        </div>

                        <img src={time_slot} alt="" className="interview-img" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "feedbacks" && (
              <div>
                <div className="cards-section  cadidate-details rating-cards-average">
                  <h2 className="h4 text-start pb-0 mb-0">
                    {t(`View Details.Rating`)}
                  </h2>

                  <div className="average-ratings">
                    <div className="average-rating-cards">
                      <div className="total-average-rating">
                        <h5>{t(`View Details.Average Rating`)}</h5>
                        <h4>
                          {averageScore || 0}{" "}
                          <span>
                            {[...Array(5)].map((_, i) => {
                              if (i < Math.floor(averageScore)) {
                                // Full star
                                return (
                                  <FontAwesomeIcon
                                    key={i}
                                    icon={faStar}
                                    style={{ color: "#FEAE44" }}
                                  />
                                );
                              } else if (
                                i === Math.floor(averageScore) &&
                                averageScore % 1 >= 0.5
                              ) {
                                // Half star
                                return (
                                  <FontAwesomeIcon
                                    key={i}
                                    icon={faStarHalfAlt}
                                    style={{ color: "#FEAE44" }}
                                  />
                                );
                              } else {
                                // Empty star
                                return (
                                  <FontAwesomeIcon
                                    key={i}
                                    icon={faStarHalfAlt}
                                    style={{ color: "#E0E0E0" }} // or your choice of color for empty stars
                                  />
                                );
                              }
                            })}
                          </span>
                        </h4>
                      </div>

                      <div className="total-average-rating">
                        <h5>{t(`View Details.Total Rating`)}</h5>
                        <h4>
                          {allFeedbacks?.length || 0}{" "}
                          {t(`View Details.Reviews`)}
                        </h4>
                      </div>
                    </div>

                    <div className="rating-review-item">
                      <div className="right-rating">
                        <ul className="order-list">
                          {[5, 4, 3, 2, 1].map(rating => (
                            <li key={rating}>
                              <div className="star-value">
                                <FontAwesomeIcon icon={faStar} />
                                <h5>{rating}</h5>
                              </div>
                              <div className="progress">
                                <div
                                  className="progress-bar"
                                  role="progressbar"
                                  style={{
                                    width: `${
                                      ((ratingCounts?.[rating] || 0) /
                                        (allFeedbacks?.length || 1)) *
                                      100
                                    }%`,
                                    backgroundColor:
                                      rating >= 4
                                        ? "#28a745"
                                        : rating === 3
                                        ? "#ffc107"
                                        : "#dc3545",
                                  }}
                                  aria-valuenow={
                                    ((ratingCounts?.[rating] || 0) /
                                      (allFeedbacks?.length || 1)) *
                                    100
                                  }
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                ></div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="cards-section  cadidate-details feedback-cardsp">
                  <h2 className="h4 text-start pb-0 mb-0">
                    {t(`View Details.Candidate Interview Feedbacks`)}
                  </h2>

                  <div className="feedback-dat-length">
                    {allFeedbacks && allFeedbacks.length > 0 ? (
                      allFeedbacks.map((feedback, index) => (
                        <div
                          className="candidate-interview-fedback green-line-card"
                          key={index}
                        >
                          <div className="sucess-img-logical">
                            <div className="sucess-img">
                              <span className="green-s">
                                {/* <img
                                  src="/path/to/your/icon.png"
                                  alt="feedback icon"
                                /> */}
                                <img src={cricle_check} alt="green icon" />
                              </span>
                            </div>
                            <h5>
                              {feedback.InterviewTitle?.interview_title ||
                                t(`View Details.Interview Round`)}
                            </h5>
                          </div>

                          <div className="review-feedback-card">
                            <div className="feedback-name-card">
                              <div className="feedback-images">
                                <span>
                                  {/* <img
                                    src={
                                      feedback.user.image ||
                                      "/path/to/default-avatar.png"
                                    }
                                    alt="avatar"
                                  /> */}

                                  <img src={smith_img} alt="" />
                                </span>
                                <div className="date-timeso">
                                  <h6 className="text-capitalize">
                                    {feedback.user.username},{" "}
                                    <span>{feedback.user.role?.name}</span>
                                  </h6>
                                  <p>
                                    {feedback.createdAt
                                      ? moment(feedback.createdAt).format(
                                          "Do MMM'YY, hh:mm a"
                                        )
                                      : ""}
                                  </p>
                                </div>
                              </div>

                              <div className="feedback-contents">
                                <span>
                                  {[...Array(5)].map((_, i) => {
                                    if (i < Math.floor(averageScore)) {
                                      // Full star
                                      return (
                                        <FontAwesomeIcon
                                          key={i}
                                          icon={faStar}
                                          style={{ color: "#FEAE44" }}
                                        />
                                      );
                                    } else if (
                                      i === Math.floor(averageScore) &&
                                      averageScore % 1 >= 0.5
                                    ) {
                                      // Half star
                                      return (
                                        <FontAwesomeIcon
                                          key={i}
                                          icon={faStarHalfAlt}
                                          style={{ color: "#FEAE44" }}
                                        />
                                      );
                                    } else {
                                      // Empty star
                                      return (
                                        <FontAwesomeIcon
                                          key={i}
                                          icon={faStarHalfAlt}
                                          style={{ color: "#E0E0E0" }} // or your choice of color for empty stars
                                        />
                                      );
                                    }
                                  })}
                                  <p>{averageScore}</p>
                                </span>
                                <p>{feedback.comments}</p>
                              </div>
                            </div>
                          </div>
                          <div className="feedback-border"></div>
                        </div>
                      ))
                    ) : (
                      // <p>{t(`View Details.No feedback available`)}</p>
                      <div className="no-data data-available">
                        <img
                          src="../../img/data-not-available.png"
                          alt="data not availble"
                        />
                        <h3>{t(`View Details.No feedback available`)}</h3>
                        <p>
                          {t(`View Details.Sorry, we could not find any`)}
                          <br /> {t(`View Details.Item to show here`)}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {activeTab === "communication" && (
              <div>
                <div className="view-details-card pt-2">
                  <div className="card-header d-flex align-items-center justify-content-between pb-2">
                    <h2 className="h4 text-start pb-0 mb-0">
                      {t(`View Details.Communication Logs`)}
                    </h2>

                    <div className="tale-text right-panel mobile-arrow pb-0 mb-0">
                      <button
                        className="button left"
                        onClick={() => handleScroll("left")}
                        data-tooltip={t(`View Details.Scroll Left`)}
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                      <button
                        className="button right"
                        onClick={() => handleScroll("right")}
                        data-tooltip={t(`View Details.Scroll Right`)}
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                    </div>
                  </div>
                  <div className="mt-2">
                    <div className="tabel-application table-responsive white-space-row CommunicationLogs  pb-3">
                      <div className="timeto-hire-card userlist">
                        <div className="table-custome-class range-custome">
                          <div className="scroll-container">
                            <div className="table-pending-list">
                              <div
                                className="table-wrapper"
                                ref={tableWrapperRef}
                              >
                                <table className="table table-bordered table-responisve">
                                  <thead>
                                    <tr>
                                      <th>{t(`View Details.Serial No`)}</th>
                                      <th>{t(`View Details.Description`)}</th>
                                      <th>{t(`View Details.Position`)}</th>
                                      <th>{t(`View Details.Medium`)}</th>
                                      <th>{t(`View Details.Date`)}</th>
                                      <th>{t(`View Details.Status`)}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {communicationLogs?.map((el, index) => {
                                      return (
                                        <tr key={index}>
                                          <td className="text-start">
                                            {index + 1}
                                          </td>
                                          <td className="text-start">
                                            {el?.action}
                                          </td>
                                          <td className="text-start">
                                            {el?.vacancy?.title || ""}
                                          </td>
                                          <td className="text-start">
                                            {el?.type}
                                          </td>
                                          <td className="text-start">
                                            {el?.createdAt
                                              ? moment(
                                                  getCompanyTimezoneDateTime(
                                                    el?.createdAt
                                                  )
                                                ).format("Do MMM'YY, hh:mm a")
                                              : ""}
                                          </td>
                                          <td className="text-start">
                                            {el?.status === "Success" ? (
                                              <span className="text-success">
                                                {t(`View Details.Success`)}
                                              </span>
                                            ) : (
                                              <span className="text-danger">
                                                {t(`View Details.Failure`)}
                                              </span>
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                                {communicationLogs?.length === 0 && (
                                  <div className="no-data data-available">
                                    <img
                                      src="../../img/data-not-available.png"
                                      alt="data not available"
                                    />
                                    <h3>{t(`View Details.No Item Found`)}</h3>
                                    <p>
                                      {t(
                                        `View Details.Sorry, we could not find any`
                                      )}
                                      <br />{" "}
                                      {t(`View Details.Item to show here`)}
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "notes" && (
              <div>
                <div className="row mt-4">
                  {allNotes?.length > 0 &&
                    allNotes?.map(el => {
                      return (
                        <Col lg={4} className="mb-4">
                          <div className="chat-nots-card">
                            <div className="chat-header">
                              <div>
                                <h6>{el?.user?.name || ""} </h6>
                                <p>({el?.user?.email || ""}) </p>
                              </div>
                              <div
                                className="delete-icon cursor-pointer"
                                title={t(`View Details.Remove Note`)}
                                onClick={() => handleRemoveNote(el)}
                              >
                                <span>
                                  <img src={delete_icon} alt="delete icon" />
                                </span>
                              </div>
                            </div>
                            <div className="chat-comment">
                              <p>
                                {readMoreStates[el.id]
                                  ? el?.note
                                  : `${el?.note.substring(0, 250)}`}

                                {el?.note.length > 250 && (
                                  <button
                                    onClick={() => toggleReadMore(el.id)}
                                    className="btn btn-link"
                                  >
                                    {readMoreStates[el.id]
                                      ? t(`View Details.Read Less`)
                                      : t(`View Details.Read More`)}
                                  </button>
                                )}
                              </p>
                            </div>

                            <div className="chat-footer">
                              <div className="chat-calender">
                                {/* <span>
                                    <img src={calednder} alt="" />
                                  </span> */}
                                <p>
                                  {el?.createdAt
                                    ? moment(
                                        getCompanyTimezoneDateTime(
                                          el?.createdAt
                                        )
                                      ).format("Do MMM'YY | hh:mm a")
                                    : ""}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  {allNotes?.length === 0 && (
                    <>
                      <div className="no-data data-available">
                        <img
                          src="../../img/data-not-available.png"
                          alt="data not available"
                        />
                        <h3>{t(`View Details.No Item Found`)}</h3>
                        <p>
                          {t(`View Details.Sorry, we could not find any`)}
                          <br />
                          {t(`View Details.Item to show here`)}
                        </p>
                      </div>
                    </>
                  )}

                  {/* {allNotes?.length > 0 &&
                      allNotes?.map(el => {
                        return (
                          <Col lg={4}>
                          <div className="chat-notes">
                            
                            <div className="chat-notes-header">
                              
                              <div
                                  className="delete-icon cursor-pointer"
                                  title="Remove Note"
                                  onClick={() => handleRemoveNote(el)}
                                >
                                  <span>
                                    <img src={delete_icon} alt="delete icon" />
                                  </span>
                                </div>

                                <p>{el?.note}</p>
                              <div className="d-flex gap-2">
                                <div className="chat-calender">
                                  <span>
                                    <img src={calednder} alt="" />
                                  </span>
                                  <p>
                                    {el?.createdAt
                                      ? moment(
                                          getCompanyTimezoneDateTime(
                                            el?.createdAt
                                          )
                                        ).format("Do MMM'YY, hh:mm a")
                                      : ""}
                                  </p>
                                </div>
                                
                              </div>
                            </div>
                          </div>
                          </Col>
                        );
                      })}
                    {allNotes?.length === 0 && <p>No Data Available.</p>} */}
                </div>
              </div>
            )}
            {activeTab === "comments" && (
              <div>
                <div className="row mt-4">
                  {/* No Data */}
                  {remarksHistory?.length === 0 && (
                    <div className="no-data data-available">
                      <h3>{t(`View Details.No comments available`)}</h3>
                    </div>
                  )}

                  {/* Remarks List */}
                  {remarksHistory?.map((item, index) => {
                    const statusLabel =
                      item?.activityLog?.old_status || "Unknown";

                    return (
                      <Col lg={4} className="mb-4" key={item.id || index}>
                        <div className="chat-nots-card">
                          {/* HEADER */}
                          <div className="chat-header d-flex justify-content-between">
                            <div>
                              <h6>{item?.addedByUser?.name || ""}</h6>
                              <p>
                                {moment(item.createdAt).format(
                                  "Do MMM'YY | hh:mm a"
                                )}
                              </p>
                            </div>

                            {/* ✅ STATUS CHANGE FROM */}
                            <span
                              style={{
                                backgroundColor: "#0dcaf0",
                                color: "#fff",
                                padding: "4px 10px",
                                borderRadius: "12px",
                                fontSize: "12px",
                                fontWeight: "600",
                                height: "fit-content",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {statusLabel}
                            </span>
                          </div>

                          {/* COMMENT BODY */}
                          <div className="chat-comment">
                            {/* REJECT REASON */}
                            {item?.remark?.action_type === "reject" &&
                              item?.remark?.remark_label && (
                                <div className="mb-2">
                                  <span className="badge badge-danger">
                                    Rejected Reason
                                  </span>
                                  <p className="mt-1 fw-semibold text-danger">
                                    {item.remark.remark_label}
                                  </p>
                                </div>
                              )}

                            {/* COMMENT TEXT */}
                            <p>{item.comment || "-"}</p>

                            {/* OTHER ACTION TYPES */}
                            {item?.remark?.action_type &&
                              item?.remark?.action_type !== "reject" && (
                                <div className="mt-2">
                                  <span className="badge badge-secondary text-capitalize">
                                    {item.remark.action_type}
                                  </span>
                                  {item?.remark?.remark_label && (
                                    <span className="badge badge-primary ms-2">
                                      {item.remark.remark_label}
                                    </span>
                                  )}
                                </div>
                              )}
                          </div>
                        </div>
                      </Col>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>

        <Modal
          size="lg"
          show={editModal}
          onHide={() => {
            setEditModal(false);
            setEditUserData({});
          }}
          className="edit-modal-card userdetailsmodal paddingmodal-card"
        >
          <Modal.Header closeButton>
            <Modal.Title>{t(`View Details.Edit User Details`)}</Modal.Title>
          </Modal.Header>
          <div className="bordertops"></div>
          <Modal.Body>
            <div className="">
              <Row className="">
                <Col md={12} className="mt-2">
                  <Form.Group>
                    <div>
                      <label className="btn btn-primary upload-button">
                        <FontAwesomeIcon icon={faUpload} />
                        <span className="mx-2">
                          {t(`View Details.Upload Resume`)}
                        </span>
                        <input
                          type="file"
                          multiple
                          onChange={e => {
                            handleFileUploadForResume(e);
                          }}
                          accept=".doc,.docx,.pdf,.msword,.vnd.openxmlformats-officedocument.wordprocessingml.document"
                          style={{ display: "none" }}
                        />
                      </label>
                      {resumeFile && (
                        <FontAwesomeIcon
                          className="mx-1"
                          icon={faImages}
                          style={{ cursor: "pointer" }}
                          width={"25px"}
                          height={"25px"}
                          onClick={() => handleAttachmentOpen()}
                        />
                      )}
                    </div>
                    <p>{t(`View Details.Supported file types are`)}</p>
                    {errors?.resume && (
                      <p className="text-danger mt-2 mx-1">{errors?.resume}</p>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} className="mt-3">
                  <Form.Group className="mb-3 floating-label">
                    <Form.Label className="float-label">
                      {t(`View Details.User Name`)}
                    </Form.Label>
                    <Form.Control
                      placeholder={t(`View Details.Enter Name`)}
                      type="text"
                      name="name"
                      value={editUserData?.name}
                      onChange={e => {
                        setEditUserData({
                          ...editUserData,
                          name: e.target.value,
                        });
                        setErrors({
                          ...errors,
                          name: "",
                        });
                      }}
                      title={t(`View Details.User Name`)}
                    />
                    {errors?.name && (
                      <p className="text-danger">{errors?.name}</p>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} className="mt-3">
                  <Form.Group className="mb-3 floating-label">
                    <Form.Label className="float-label">
                      {t(`View Details.Email ID`)}
                    </Form.Label>
                    <Form.Control
                      placeholder={t(`View Details.Enter Email ID`)}
                      type="text"
                      name="email_id"
                      value={generateMaskedPII(editUserData?.email_id)}
                      onChange={e => {
                        setEditUserData({
                          ...editUserData,
                          email_id: e.target.value,
                        });
                        setErrors({
                          ...errors,
                          email_id: "",
                        });
                      }}
                      disabled={
                        !checkPermissionStatus(
                          "personal-id-info",
                          "view_unmasked"
                        )
                      }
                      title={t(`View Details.Email ID`)}
                    />
                    {errors?.email_id && (
                      <p className="text-danger">{errors?.email_id}</p>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} className="mt-2">
                  <Form.Group className="mb-3 floating-label">
                    <Form.Label className="float-label">
                      {t(`View Details.Mobile Number`)}
                    </Form.Label>
                    <Form.Control
                      placeholder={t(`View Details.Enter Mobile Number`)}
                      type="text"
                      name="mobile"
                      value={generateMaskedPII(editUserData?.mobile, 2)}
                      onChange={e => {
                        setEditUserData({
                          ...editUserData,
                          mobile: e.target.value,
                        });
                        setErrors({
                          ...errors,
                          mobile: "",
                        });
                      }}
                      disabled={
                        !checkPermissionStatus(
                          "personal-id-info",
                          "view_unmasked"
                        )
                      }
                      title={t(`View Details.Mobile Number`)}
                    />
                    {errors?.mobile && (
                      <p className="text-danger">{errors?.mobile}</p>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} className="mt-2">
                  <Form.Label className="float-label">
                    {t(`View Details.Gender`)}
                  </Form.Label>
                  <div
                    title={
                      editUserData.gender
                        ? `${
                            genderData.find(
                              elem => elem.value == editUserData.gender
                            )?.label
                          }`
                        : `${t(`EmployeeReferral.Status`)}`
                    }
                  >
                    <Select
                      id="gender"
                      placeholder={t(`View Details.Select Gender`)}
                      name="gender"
                      value={genderData?.find(
                        el => el?.id === editUserData?.gender
                      )}
                      options={genderData}
                      onChange={e => {
                        setEditUserData({
                          ...editUserData,
                          gender: e?.id,
                        });
                        setErrors({
                          ...errors,
                          gender: "",
                        });
                      }}
                    />
                  </div>
                  {errors?.gender && (
                    <p className="text-danger">{errors?.gender}</p>
                  )}
                </Col>
                <Col md={6} className="mt-2">
                  <Form.Label className="float-label">
                    {t(`View Details.Date of Birth`)}
                  </Form.Label>
                  <DatePicker
                    placeholder={t(`View Details.Start Date`)}
                    title={t(`View Details.Date of Birth`)}
                    className="form-control"
                    type={"date"}
                    onChange={e => {
                      setEditUserData({
                        ...editUserData,
                        dob: e,
                      });
                      setErrors({
                        ...errors,
                        dob: "",
                      });
                    }}
                    placeholderText={t(`View Details.Enter Date of Birth`)}
                    id="date"
                    dateFormat="dd-MMM-yyyy"
                    showYearDropdown
                    selected={editUserData?.dob || ""}
                    maxDate={new Date().setFullYear(
                      new Date().getFullYear() - 18
                    )}
                    maximumDate={new Date().setFullYear(
                      new Date().getFullYear() - 18
                    )}
                  />
                  {errors?.dob && <p className="text-danger">{errors?.dob}</p>}
                </Col>
                <Col md={6} className="mt-2">
                  <Form.Label className="float-label">
                    {t(`View Details.Job Portal`)}
                  </Form.Label>

                  <div
                    title={
                      editUserData.job_portal_name
                        ? `${
                            hiringSouces.find(
                              elem => elem.value == editUserData.job_portal_name
                            )?.label
                          }`
                        : `${t(`EmployeeReferral.Status`)}`
                    }
                  >
                    <Select
                      id="job_portal_name"
                      placeholder={t(`View Details.Select Job Portal`)}
                      name="job_portal_name"
                      value={hiringSouces?.find(
                        el => el?.value === editUserData?.job_portal_name
                      )}
                      options={hiringSouces}
                      onChange={e => {
                        setEditUserData({
                          ...editUserData,
                          job_portal_name: e?.value,
                        });
                        setErrors({
                          ...errors,
                          job_portal_name: "",
                        });
                      }}
                    />
                  </div>
                  {errors?.job_portal_name && (
                    <p className="text-danger">{errors?.job_portal_name}</p>
                  )}
                </Col>

                <Col md={12}>
                  <div className="serach-btn">
                    <button
                      className="btn btn-primary reset"
                      type="button"
                      onClick={handleCancelEdit}
                    >
                      {t(`View Details.Cancel`)}
                    </button>
                    <Button color="success" onClick={() => handleUserSubmit()}>
                      {t(`View Details.Submit`)}
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </Modal.Body>
        </Modal>

        {videoUrl && (
          <>
            <div className="video-popup">
              <button className="close-button" onClick={closeVideoPopup}>
                <img src={close_icon} alt="" />
              </button>
              <div className="video-container">
                <ReactPlayer
                  url={videoUrl}
                  width="100%"
                  height="500px"
                  playing
                  controls={true} // Show native player controls
                />{" "}
              </div>
            </div>
            <div class="shadow-back"></div>
          </>
        )}

        {checkPermissionStatus("candidate-consolidate", "notes") && (
          <div className="chatbox-notes" onClick={handleDivClick}>
            {/* <span>
              <img
                src={create_notes_plus}
                alt="notes"
                className="create-notes01"
              />
              <img
                src={create_notes_plus1}
                alt="notes"
                className="create-notes02"
              />
            </span> */}
            <span>
              <img src={plus_icon} alt="plus" />
            </span>
            {t(`View Details.Add Notes`)}
          </div>
        )}

        {isButtonVisible && (
          <>
            <div className="chatbox-notes-popup">
              {/* <div
                className="crossbtn"
                onClick={handleCloseClick}
                style={{ cursor: "pointer", fontWeight: "bold" }}
              >
                <img src={cross} alt="cross" />
              </div> */}

              <div className="name-candidate">
                {/* <h4>Notes - {candidateDetails?.job_user?.name || ""}</h4> */}

                <h4>{t(`View Details.Key Remarks on Candidate`)}</h4>

                <div
                  className="crossbtn"
                  onClick={handleCloseClick}
                  style={{ cursor: "pointer", fontWeight: "bold" }}
                >
                  <img src={cross} alt="cross" />
                </div>
              </div>
              <div className="bordertops"></div>
              <div className="chatbox-search-box">
                <Form onSubmit={e => e.preventDefault()}>
                  <Form.Group
                    className="w-100"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>
                      {t(`View Details.Write Your Notes Here`)}
                    </Form.Label>
                    <textarea
                      className="form-control"
                      placeholder={t(`View Details.Add Notes`)}
                      value={noteString}
                      onChange={e => setNoteString(e.target.value)}
                      title={`${t(`View Details.Write Your Notes Here`)}`}
                    />
                    <p>
                      {t(
                        `View Details.300 characters remaining to reach the max limit`
                      )}
                    </p>
                  </Form.Group>

                  <Form.Group className="cta text-center gap-3 d-flex justify-content-left mt-4 mb-4">
                    <button
                      className="btn btn-secondary"
                      onClick={handleCloseClick}
                    >
                      {t(`View Details.Cancel`)}
                    </button>
                    <button
                      className="serach btn btn-primary"
                      onClick={() => handleAddNote()}
                    >
                      {t(`View Details.Save`)}
                    </button>
                  </Form.Group>
                </Form>
              </div>
            </div>
            <div className="backcover-modal"></div>
          </>
        )}
      </div>
      <Modal
        show={showPositionModal}
        onHide={handleClosePositionModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Position</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Current Position */}
          <Form.Group className="mb-3">
            <Form.Label>Current Position</Form.Label>
            <Form.Control
              type="text"
              value={candidateDetails?.vacancy?.title || ""}
              readOnly
              className="bg-light"
            />
          </Form.Group>

          {/* New Position */}
          <Form.Group>
            <Form.Label>
              New Position <span className="text-danger">*</span>
            </Form.Label>

            <Select
              options={jobList}
              value={selectedJob}
              onChange={setSelectedJob}
              placeholder="Select Position"
              isClearable
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>
              Reason <span className="text-danger">*</span>
            </Form.Label>

            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter reason for changing position"
              value={positionChangeReason}
              onChange={e => setPositionChangeReason(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClosePositionModal}>
            Cancel
          </Button>

          <Button
            variant="primary"
            onClick={handlePositionUpdate}
            disabled={!selectedJob || !positionChangeReason?.trim()}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Updating...
              </>
            ) : (
              "Update Position"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ViewDetails;
